import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import { notaCxPPorId } from "../../CXP/NotasCxP/notaCxPPDF";
import { PDFOC } from "./ordenCompraExternaPDF";
import ConsumosTelasModal from "../../Ventas/Pedidos/ConsumosTelasModal";
// (2026-07) buscador autocomplete de habilitación en "Entregar Habilitacion"
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import { makeStyles } from "@material-ui/core/styles";
import BajaMultiple from "../../BajaMultiple";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

// (2026-10) cliente con la subárea de la orden entre paréntesis
const conSubArea = (cliente, subArea) => {
  const t = String(subArea ?? "").trim();
  return t && t.toUpperCase() !== "NA" ? `${cliente} (${t})` : cliente;
};

function ListadoOrdenesCorteExterno() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ORDENES_CORTE_EXTERNO =
    process.env.REACT_APP_URL_ORDENES_CORTE_EXTERNO;
  const URL_ARTICULOS_ORDENES_CORTE_EXTERNO =
    process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE_EXTERNO;
  const URL_INVENTARIOS_TELAS = process.env.REACT_APP_URL_INVENTARIOS_TELAS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  // L3 (2026-06)
  const URL_DEVOLUCIONES_PROVEEDORES = process.env.REACT_APP_URL_DEVOLUCIONES_PROVEEDORES;
  const URL_DEVOLUCIONES_PROVEEDORES_ACUMULADOS = process.env.REACT_APP_URL_DEVOLUCIONES_PROVEEDORES_ACUMULADOS;
  const URL_EXPLOSION = process.env.REACT_APP_URL_EXPLOSION;
  const URL_EXPLOSION_GLOBAL = process.env.REACT_APP_URL_EXPLOSION_GLOBAL;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  // L113 (2026-06) — catálogo de colores para agregar talla/color en el modal Editar
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  // (2026-07) Consumos de telas por pedido (igual que ListadoPedidos)
  const URL_CONSUMO_TELAS = process.env.REACT_APP_URL_CONSUMO_TELAS;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  // (2026-07) catálogo de tallas (con variantes) para editar la talla en el modal
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  // Agregar Tela a Orden de Produccion
  const URL_TELAS_ORDENES_CORTE = process.env.REACT_APP_URL_TELAS_ORDENES_CORTE;
  const URL_TELAS_ORDENES_CORTES_ACUMULADOS =
    process.env.REACT_APP_URL_TELAS_ORDENES_CORTES_ACUMULADOS;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
  const URL_HABILITACION_ORDENES_CORTES =
    process.env.REACT_APP_URL_HABILITACION_ORDENES_CORTES;
  const URL_DETALLE_HABILITACION_ORDENES_CORTES =
    process.env.REACT_APP_URL_DETALLE_HABILITACION_ORDENES_CORTES;
  // Procesos a maquileros (salida / entrada) + NotasCxP
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_CATALOGO_PROCESOS = process.env.REACT_APP_URL_CATALOGO_PROCESOS;
  const URL_PROCESOS_SALIDA = process.env.REACT_APP_URL_PROCESOS_SALIDA;
  const URL_ARTICULOS_PROCESOS_SALIDA =
    process.env.REACT_APP_URL_ARTICULOS_PROCESOS_SALIDA;
  const URL_PROCESOS_ENTRADA = process.env.REACT_APP_URL_PROCESOS_ENTRADA;
  const URL_ARTICULOS_PROCESOS_ENTRADA =
    process.env.REACT_APP_URL_ARTICULOS_PROCESOS_ENTRADA;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");
const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];
  const [ordenesCorte, setOrdenesCorte] = useState([]);

  const [inventarios, setInventarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  // TF4 — filtro de proveedor (igual al de cliente)
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedRecibido, setSelectedRecibido] = useState("");
  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");
  const [selectedCortado, setSelectedCortado] = useState("No");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [articulosEdit, setArticulosEdit] = useState([]);
  // (2026-07) catálogo de tallas (con variantes) para el select de Talla en el modal Editar
  const [tallasEdit, setTallasEdit] = useState([]);
  const [total_piezas, setTotalPiezas] = useState(0);
  const [totalGeneral, setTotalGeneral] = useState(0);
  // L113 (2026-06) — agregar talla/color del mismo artículo en el modal Editar
  const [agregarArticulo, setAgregarArticulo] = useState(""); // idArticulo
  const [agregarTallas, setAgregarTallas] = useState([]); // catálogo de tallas del artículo
  const [agregarColores, setAgregarColores] = useState([]); // catálogo completo de colores
  const [agregarTalla, setAgregarTalla] = useState("");
  const [agregarColor, setAgregarColor] = useState("");
  const [agregarCantidad, setAgregarCantidad] = useState("");
  const [agregarPrecio, setAgregarPrecio] = useState("");
  // L124 (2026-06) — artículos del pedido de la orden (para agregar uno distinto que esté en el pedido)
  const [articulosPedidoEdit, setArticulosPedidoEdit] = useState([]);

  const classes = useStyles();

  const [validaBoton, setValidaBoton] = useState(true);

  const [fechaTelas, setFechaTelas] = useState(endDate);
  const [observacionesTelas, setObservacionesTelas] = useState("NA");
  const [observacionesTelasPDF, setObservacionesTelasPDF] = useState("");
  const [selectedOrdenCorte, setSelectedOrdenCorte] = useState("");
  const [selectedOrdenCorteNumero, setSelectedOrdenCorteNumero] = useState("");
  const [totalMetros, setTotalMetros] = useState("");
  const [totalKilos, setTotalKilos] = useState("");
  const [cantidadAgrupado, setCantidadAgrupado] = useState([]);
  const [articulosOrden, setArticulosOrden] = useState([]);
  const [rollosTotales, setRollosTotales] = useState(0);
  const [articulosUnicos, setArticulosUnicos] = useState([]);

  const [modalTelas, setModalTelas] = useState(false);
  const toggleTelas = () => setModalTelas(!modalTelas);

  const [explosion, setExplosion] = useState([]);
  const [idEdit, setIdEdit] = useState("");
  const [numero_pedido, setNumeroPedido] = useState("");
  const [modalExplosion, setModalExplosion] = useState(false);
  const toggleExplosion = () => setModalExplosion(!modalExplosion);

  // (2026-07) Consumos de telas por pedido (portado de ListadoPedidos)
  const [modalConsumos, setModalConsumos] = useState(false);
  const toggleConsumos = () => setModalConsumos(!modalConsumos);
  const [consumoIdPedido, setConsumoIdPedido] = useState("");
  const [consumoNumeroPedido, setConsumoNumeroPedido] = useState("");
  const [consumoCliente, setConsumoCliente] = useState("");
  const [coloresConsumo, setColoresConsumo] = useState([]);

  const [telasDevolucion, setTelasDevolucion] = useState("");
  const [idsInventario, setIdsInventario] = useState("");
  const [selectedOrdenCorteDev, setSelectedOrdenCorteDev] = useState("");
  const [selectedOrdenCorteNumeroDev, setSelectedOrdenCorteNumeroDev] =
    useState("");
  const [modalTelasDev, setModalTelasDev] = useState(false);
  const toggleTelasDev = () => setModalTelasDev(!modalTelasDev);
  const [rollosTotalesDev, setRollosTotalesDev] = useState(0);
  const [observacionesEdit, setObservacionesEdit] = useState("");

  const [statusTelaEdit, setStatusTelaEdit] = useState("");
  const [modalStatusEdit, setModalStatusEdit] = useState(false);
  const toggleStatusEdit = () => setModalStatusEdit(!modalStatusEdit);

  const [entregaHabilitacion, setEntregaHabilitacion] = useState(false);
  const [habilitacion, setHabilitacion] = useState([]);

  const [idProcesosSalidaHab, setIdProcesosSalidaHab] = useState("");
  const [idCorteHab, setIdCorteHab] = useState("");
  const [idPedidoHab, setIdPedidoHab] = useState("");
  const [idProveedorHab, setIdProveedorHab] = useState("");
  const [fechaHab, setFechaHab] = useState("");
  const [observacionesHab, setObservacionesHab] = useState("");

  // ===== Procesos a maquileros (salida/entrada) =====
  const [maquileros, setMaquileros] = useState([]);
  const [catalogoProcesos, setCatalogoProcesos] = useState([]);
  const [procesosInputFields, setProcesosInputFields] = useState([]);
  const [selectedOrdenExt, setSelectedOrdenExt] = useState("");
  const [selectedOrdenExtNumero, setSelectedOrdenExtNumero] = useState("");
  const [idPedidoProc, setIdPedidoProc] = useState("");
  const [numeroPedidoProc, setNumeroPedidoProc] = useState("");
  const [idArticuloProc, setIdArticuloProc] = useState("");
  const [maquileroProceso, setMaquileroProceso] = useState("");
  const [idCatalogoProceso, setIdCatalogoProceso] = useState("");
  const [precioProceso, setPrecioProceso] = useState(0);
  const [fechaProceso, setFechaProceso] = useState(endDate);
  const [fechaCompromisoProceso, setFechaCompromisoProceso] = useState(endDate);
  const [observacionesProceso, setObservacionesProceso] = useState("NA");
  const [totalPiezasProc, setTotalPiezasProc] = useState(0);
  const [totalGeneralProc, setTotalGeneralProc] = useState(0);
  const [totalPiezasFaltantesProc, setTotalPiezasFaltantesProc] = useState(0);
  const [totalPiezasSegundasProc, setTotalPiezasSegundasProc] = useState(0);
  const [impuestosProc, setImpuestosProc] = useState(0);
  const [facturaProc, setFacturaProc] = useState("NA");
  const [selectedProcesoSalida, setSelectedProcesoSalida] = useState("");

  const [modalSalidaProc, setModalSalidaProc] = useState(false);
  const toggleSalidaProc = () => setModalSalidaProc(!modalSalidaProc);
  const [modalEntradaLista, setModalEntradaLista] = useState(false);
  const toggleEntradaLista = () => setModalEntradaLista(!modalEntradaLista);
  const [modalEntradaProc, setModalEntradaProc] = useState(false);
  const toggleEntradaProc = () => setModalEntradaProc(!modalEntradaProc);
  const [procesosSalidaAbiertos, setProcesosSalidaAbiertos] = useState([]);

  const [PDFPS, setPDFPS] = useState([]);
  const [modalPDFPS, setModalPDFPS] = useState(false);
  const togglePDFPS = () => setModalPDFPS(!modalPDFPS);
  const [PDFPE, setPDFPE] = useState([]);
  const [modalPDFPE, setModalPDFPE] = useState(false);
  const togglePDFPE = () => setModalPDFPE(!modalPDFPE);

  const [modalHabilitacion, setModalHabilitacion] = useState(false);
  const toggleHabilitacion = () => setModalHabilitacion(!modalHabilitacion);
  const [inputFieldsHabilitacion, setInputFieldsHabilitacion] = useState([
    {
      id: uuidv4(),
      idHabilitacion: "",
      cantidad: 0,
    },
  ]);

  const [editHab, setEditHab] = useState([]);
  const [modalEditHab, setModalEditHab] = useState(false);
  const toggleEditHab = () => setModalEditHab(!modalEditHab);

  const [modalCheck, setModalCheck] = useState(false);
  const [checks, setChecks] = useState({
    Etiquetas: false,
    Tallas: false,
    Observaciones: false,
    Bordados: false,
    Modelos: false,
  });
  const [idPedidoEditando, setIdPedidoEditando] = useState(null);

  //--- Pagination
  const [comments, setComments] = useState([]);
  // (2026-08) { idOrden: [{codigo, descripcion, cantidad}] } para la columna Articulos
  const [articulosPorOrden, setArticulosPorOrden] = useState({});
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      idInventarioTelas: "",
      telas: "",
      idTela: "",
      unidad: "",
      colores: "",
      idColor: "",
      cantidadOriginal: 0,
      cantidad: 0,
      idArticulo: "",
      compras: "",
      telasOC: "",
      telaCodigo: "",
      telaNombre: "",
      telaColor: "",
    },
  ]);

  const [inputFieldsAnterior, setInputFieldsAnterior] = useState([]);

  useMemo(() => {
    axios
      .get(
        `${URL_ORDENES_CORTE_EXTERNO}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      )
      .then((response) => {
        let allOrdenes = response.data;
        // Array para pagination
        let arrayTabla = allOrdenes
          .sort((a, b) => (a.idOrdenesCorte < b.idOrdenesCorte ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idOrdenesCorteExterno,
              fecha: a.fecha,
              pedido: a.pedidos[0].idPedido,
              idPedidos: a.pedidos[0]._id,
              cortado: a.cortado,
              cliente: (() => {
                // (2026-09) subcliente entre paréntesis, como en ListadoPedidos
                const nombre = a.pedidos[0].clientes[0].nombre_comercial;
                const sub = String(a.pedidos[0].subCliente ?? "").trim();
                const base = sub && sub.toUpperCase() !== "NA" ? `${nombre} (${sub})` : nombre;
                // (2026-10) y la subárea de la orden, también entre paréntesis
                return conSubArea(base, a.subArea);
              })(),
              clienteBase: (() => {
                const nombre = a.pedidos[0].clientes[0].nombre_comercial;
                const sub = String(a.pedidos[0].subCliente ?? "").trim();
                return sub && sub.toUpperCase() !== "NA" ? `${nombre} (${sub})` : nombre;
              })(),
              subArea: String(a.subArea ?? "").trim() || "NA",
              idCliente: a.pedidos[0].clientes[0]._id,
              proveedor: a.proveedores[0].nombre_comercial,
              proveedorDireccion:
                a.proveedores[0].calle +
                " " +
                a.proveedores[0].numero_ext +
                ", " +
                a.proveedores[0].numero_int,
              proveedorMail: a.proveedores[0].email,
              idProveedores: a.proveedores[0]._id,
              idProveedor: a.proveedores[0].idProveedor || "",
              // L40 (2026-06) — vendedor del pedido para el PDFOC
              nombreFirma: a.pedidos[0]?.nombreFirma || "",
              // L106 (2026-06) — empresa del pedido (para el logo del PDF)
              empresa:
                a.pedidos[0]?.empresas?.[0]?.razonSocial ||
                a.pedidos[0]?.empresas?.[0]?.name ||
                "",
              // L128 (2026-07) — objeto empresa completo (datos fiscales header PDFOC)
              empresaObj: a.pedidos?.[0]?.empresas?.[0] || null,
              fechaCancelacion: a.pedidos[0].fecha_cancelacion,
              total_piezas: a.cantidad,
              observaciones: a.observaciones,
              observacionesPedido: a.pedidos[0].observaciones,
              marca: a.pedidos[0].marcas[0].name,
              // (2026-09) El Monarch se captura en "Observaciones Monarch" del
              // pedido (campo observaciones); observacionesMarca es el campo
              // viejo y queda sólo de respaldo. Igual que en ListadoOrdenesCorte.
              observacionesMarca: (() => {
                const obsMonarch = String(a.pedidos[0].observaciones ?? "").trim();
                const obsMarca = String(a.pedidos[0].observacionesMarca ?? "").trim();
                return obsMonarch && obsMonarch.toUpperCase() !== "NA"
                  ? obsMonarch
                  : obsMarca;
              })(),
              is_active: a.is_active,
              statusTela: a.statusTela,
              pedidoEditado: a.pedidos[0].editado,
              corteExterno: a.corteExterno,
              fechaCompromiso: a.fechaCompromiso,
              totalGeneral: a.totalGeneral,
              recibido:
                Array.isArray(a.recibidos) && a.recibidos.length > 0
                  ? "Si"
                  : "No",
              recibidos: Array.isArray(a.recibidos)
                ? a.recibidos
                    .map((r) => {
                      const u = r?.user || {};
                      const uid =
                        typeof u === "string" ? u : u?._id || "";
                      const nombre =
                        typeof u === "string"
                          ? ""
                          : `${u.nombre || ""} ${u.apellido || ""}`.trim() ||
                            u.email ||
                            "";
                      return {
                        userId: String(uid || ""),
                        nombre,
                        fecha: r?.fecha || "",
                      };
                    })
                    .filter((r) => r.userId)
                : [],
              autorizacionVarios: a.autorizacionVarios,
              // patronista: a.articulos[0].patronista[0].nombre + " " + a.articulos[0].patronista[0].apellido,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setOrdenesCorte(allOrdenes);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  useEffect(() => {
    axios
      .get(`${URL_INVENTARIOS_TELAS}Existencia`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInventarios = response.data;
        setInventarios(allInventarios);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_PROVEEDORES}Maquileros`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setMaquileros(response.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CATALOGO_PROCESOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setCatalogoProcesos(response.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_HABILITACION, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allHabilitacion = response.data;
        // Array para pagination
        let arrayTabla = allHabilitacion
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              nombre: a.nombre,
              unidad: a.unidad,
              observaciones: a.observaciones,
              descripcion: a.descripcion,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setHabilitacion(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente >= a.idCliente) &&
        (selectedRecibido == 0 || selectedRecibido >= a.recibido) &&
        (selectedArticulo == 0 || selectedArticulo >= a.idArticulo) &&
        (selectedCortado == 0 || selectedCortado >= a.cortado)
      ) {
        return [a.numero, a.fecha, a.pedido];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Ordenes Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Pedido"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Ordenes-Corte.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente >= a.idCliente) &&
        (selectedRecibido == 0 || selectedRecibido >= a.recibido) &&
        (selectedArticulo == 0 || selectedArticulo >= a.idArticulo) &&
        (selectedCortado == 0 || selectedCortado >= a.cortado)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Pedido: a.pedido,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoOrdenesCorteExterno";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoOrdenesCorteExterno",
        sheetFilter: ["Numero", "Fecha", "Pedido"],
        sheetHeader: ["Numero", "Fecha", "Pedido"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente >= a.idCliente) &&
        (selectedRecibido == 0 || selectedRecibido >= a.recibido) &&
        (selectedArticulo == 0 || selectedArticulo >= a.idArticulo) &&
        (selectedCortado == 0 || selectedCortado >= a.cortado)
      ) {
        return [a.numero, a.fecha, a.pedido];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Ordenes Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Pedido"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ordenes Compra",
          email: mailTo,
          fileName: "ListadoOrdenesCorteExterno.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Ordenes Compra.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha Creacion", field: "fecha", sortable: false },
    { name: "Cliente", field: "cliente", sortable: false },
    { name: "Proveedor", field: "proveedor", sortable: false },
    { name: "Status Tela", field: "statusTela", sortable: true },
    { name: "Monarch", field: "observacionesMarca", sortable: false },
    { name: "Marca", field: "marca", sortable: false },
    // { name: "Fecha Cancelacion", field: "fechaCancelacion", sortable: false },
    // (2026-08) artículos que trae cada orden
    { name: "Articulos", field: "articulos", sortable: false },
    { name: "Cantidad", field: "total_piezas", sortable: false },
    { name: "Observaciones", field: "observaciones", sortable: false },
    // { name: "Pedido Interno", field: "pedido", sortable: true },
    // { name: "Cortado", field: "cortado", sortable: true },
    { name: "Autorizar", field: "Autorizar", sortable: false },
    { name: "Acciones", field: "acciones", sortable: false },
    { name: "Tela", field: "Tela", sortable: false },
    { name: "Habilitacion", field: "Habilitacion", sortable: false },
    { name: "Recibido", field: "Recibido", sortable: false },
    { name: "Salida Procesos", field: "SalidaProcesos", sortable: false },
    { name: "Entrada Procesos", field: "EntradaProcesos", sortable: false },
  ];

  // (2026-08) Artículos de cada orden, para la columna del listado. Se piden en
  // bloques para no armar URLs enormes.
  useEffect(() => {
    const ids = [...new Set(comments.map((c) => c._id).filter(Boolean))].map(
      String,
    );

    if (!ids.length) {
      setArticulosPorOrden({});
      return;
    }

    let cancelado = false;
    const bloques = [];
    for (let i = 0; i < ids.length; i += 60) bloques.push(ids.slice(i, i + 60));

    Promise.all(
      bloques.map((b) =>
        axios
          .get(
            `${URL_ARTICULOS_ORDENES_CORTE_EXTERNO}/articulosOrdenes/${b.join(",")}`,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            },
          )
          .then((r) => r.data || {})
          .catch((err) => {
            console.log("articulosOrdenes err:", err);
            return {};
          }),
      ),
    ).then((partes) => {
      if (cancelado) return;
      const mapa = {};
      partes.forEach((p) =>
        Object.keys(p).forEach((k) => {
          mapa[k] = p[k] || [];
        }),
      );
      setArticulosPorOrden(mapa);
    });

    return () => {
      cancelado = true;
    };
  }, [comments]);

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.fecha.toLowerCase().includes(search.toLowerCase()) ||
          comment.proveedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.observacionesPedido
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.observacionesMarca
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.statusTela.toLowerCase().includes(search.toLowerCase()) ||
          comment.fechaCancelacion
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.cortado.toLowerCase().includes(search.toLowerCase()) ||
          comment.numero.toString().includes(search) ||
          comment.total_piezas.toString().includes(search) ||
          comment.pedido.toString().includes(search) ||
          // (2026-08) artículos de la orden (código y descripción)
          (articulosPorOrden[comment._id] || [])
            .map((art) => `${art.codigo} ${art.descripcion}`)
            .join(" ")
            .toLowerCase()
            .includes(search.toLowerCase()),
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio,
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin,
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idCliente.includes(selectedCliente),
      );
    }
    // TF4 — filtro de proveedor
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        String(e.idProveedores || "").includes(selectedProveedor),
      );
    }
    if (selectedRecibido) {
      computedComments = computedComments.filter((e) =>
        e.recibido.includes(selectedRecibido),
      );
    }
    // if (selectedArticulo) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idArticulo.includes(selectedArticulo)
    //   );
    // }
    if (selectedCortado) {
      computedComments = computedComments.filter((e) =>
        e.cortado.includes(selectedCortado),
      );
    }
    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_piezas" &&
      sorting.field != "numero" &&
      sorting.field != "pedido"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field]),
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "numero" ||
        sorting.field == "total_piezas" ||
        sorting.field == "pedido")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1,
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "numero" ||
        sorting.field == "total_piezas" ||
        sorting.field == "pedido")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1,
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE,
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedCliente,
    selectedProveedor,
    selectedRecibido,
    selectedArticulo,
    selectedCortado,
    articulosPorOrden,
  ]);

  let totalCantidad = 0;
  let totalCortado = 0;
  let totalPendCortar = 0;

  function statusEdit(id, statusTela) {
    setIdEdit(id);
    setStatusTelaEdit(statusTela);
    toggleStatusEdit();
  }

  async function toggleRecibido(id, recibidosActuales) {
    try {
      const lista = Array.isArray(recibidosActuales) ? recibidosActuales : [];
      const yaMarcado = lista.some(
        (r) => String(r.userId || "") === String(user.id)
      );
      const hoy = moment().format("YYYY-MM-DD HH:mm");

      let nuevosRecibidos;
      if (yaMarcado) {
        nuevosRecibidos = lista
          .filter((r) => String(r.userId || "") !== String(user.id))
          .map((r) => ({ user: r.userId, fecha: r.fecha || "" }));
      } else {
        nuevosRecibidos = [
          ...lista.map((r) => ({ user: r.userId, fecha: r.fecha || "" })),
          { user: user.id, fecha: hoy },
        ];
      }

      await axios.patch(
        `${URL_ORDENES_CORTE_EXTERNO}/${id}`,
        { recibidos: nuevosRecibidos },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      await axios.post(
        URL_LOGS,
        {
          tipo: yaMarcado ? "Quitar Recibido OCE" : "Recibir Orden Corte Externo",
          detalle: `Orden ${id}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      // L38 (2026-06) — actualizar state local en vez de hacer reload completo
      setComments((prev) =>
        prev.map((c) => {
          if (String(c._id) !== String(id)) return c;
          const updatedRecibidos = nuevosRecibidos.map((r) => {
            const existente = (c.recibidos || []).find(
              (x) => String(x.userId) === String(r.user)
            );
            if (existente) return { ...existente, fecha: r.fecha };
            if (String(r.user) === String(user.id)) {
              return {
                userId: String(user.id),
                nombre: `${user.nombre || ""} ${user.apellido || ""}`.trim(),
                fecha: r.fecha,
              };
            }
            return { userId: String(r.user), nombre: "", fecha: r.fecha };
          });
          return {
            ...c,
            recibidos: updatedRecibidos,
            recibido: updatedRecibidos.length > 0 ? "Si" : "No",
          };
        })
      );

      Swal.fire({
        icon: "success",
        title: yaMarcado ? "Quitaste tu recibido" : "Marcado como recibido",
        timer: 1000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al actualizar recibido:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo actualizar el recibido.",
      });
    }
  }
  function saveStatusEdit(event) {
    event.preventDefault();
    axios
      .patch(
        `${URL_ORDENES_CORTE_EXTERNO}/${idEdit}`,
        {
          statusTela: statusTelaEdit,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      )
      .then((response) => {
        axios
          .post(
            URL_LOGS,
            {
              tipo: "Editar Status",
              detalle: `Corte ${idEdit}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            },
          )
          .then(() => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Listo",
              showConfirmButton: false,
              timer: 2000,
            });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  async function requisicion(id, numero) {
    setExplosion([]);
    toggleProgreso();
    setIdEdit(id);
    setNumeroPedido(numero);
    axios
      .get(`${URL_ARTICULOS_ORDENES_CORTE_EXTERNO}/orden/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async (response) => {
        let allArticulosPedido = response.data;
        let arrayTabla = await allArticulosPedido
          .map((a) => {
            return {
              id: a._id,
              activo: a.is_active,
              articulos: a.articulosPedido[0].articulos[0]._id,
              articulosCodigo:
                a.articulosPedido[0].articulos[0].codigo +
                " / " +
                a.articulosPedido[0].articulos[0].codigoCliente,
              colores: a.articulosPedido[0].colores[0]._id,
              coloresName: a.articulosPedido[0].colores[0].name,
              cantidad: a.cantidad,
              surtido: a.articulosPedido[0].surtido,
              pendiente_surtir: a.articulosPedido[0].pendiente_surtir,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);

        let agrupado = data.reduce(function (groups, item) {
          const val = item["articulos"];
          groups[val] = groups[val] || {
            articulos: item.articulos,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].articulos = item.articulos;
          groups[val].articulosCodigo = item.articulosCodigo;
          return groups;
        }, []);

        let dataFinal = Object.values(agrupado);

        let agrupadoColores = data.reduce(function (groups, item) {
          const val = item["articulos"] + item["colores"];
          groups[val] = groups[val] || {
            articulos: item.articulos,
            colores: item.colores,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].articulos = item.articulos;
          groups[val].articulosCodigo = item.articulosCodigo;
          groups[val].colores = item.colores;
          groups[val].coloresName = item.coloresName;
          return groups;
        }, []);

        let dataFinalColores = Object.values(agrupadoColores);

        let temp2 = [];

        let exp = await dataFinal.map((a) => {
          axios
            .get(`${URL_EXPLOSION}Articulo/${a.articulos}`, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((response) => {
              let allExplosion = response.data;
              let arrayExp = allExplosion
                .map((b) => {
                  if (b.habilitacion != "") {
                    temp2.push({
                      articulos: a.articulos,
                      articulosCodigo: a.articulosCodigo,
                      material:
                        b.habilitacion[0].nombre +
                        " " +
                        b.habilitacion[0].descripcion,
                      cantidadTotal: b.cantidad * a.cantidad,
                      cantidad: b.cantidad,
                      colores: "NA",
                      coloresName: "NA",
                    });
                  }
                })
                .filter(function (el) {
                  return el != null;
                });
            })
            .catch((err) => {
              console.log(err);
            });
        });

        let expColores = await dataFinalColores.map((a) => {
          axios
            .get(`${URL_EXPLOSION}Articulo/${a.articulos}`, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((response) => {
              let allExplosion = response.data;
              let arrayExp = allExplosion
                .map((b) => {
                  if (b.telas != "") {
                    temp2.push({
                      articulos: a.articulos,
                      articulosCodigo: a.articulosCodigo,
                      material: b.telas[0].nombre,
                      cantidadTotal: b.cantidad * a.cantidad,
                      cantidad: b.cantidad,
                      colores: a.colores,
                      coloresName: a.coloresName,
                    });
                  }
                })
                .filter(function (el) {
                  return el != null;
                });
            })
            .catch((err) => {
              console.log(err);
            });
        });
        setExplosion(temp2);
        setTimeout(() => {
          setModalProgreso(false);
          toggleExplosion();
        }, 3500);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function telasCortes(id, numero) {
    toggleProgreso();
    axios
      .get(`${URL_TELAS_ORDENES_CORTES_ACUMULADOS}/ordenCorte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInputFieldsAnterior = response.data;
        let tablaTelas = allInputFieldsAnterior.map((a) => {
          return {
            articulo:
              a.articulos[0].codigo +
              " / " +
              a.articulos[0].codigoCliente +
              " / " +
              a.articulos[0].descripcion,
            tela: a.telas[0].nombre,
            color: a.colores[0].name,
            unidad: a.telas[0].unidad,
            cantidad: a.cantidad,
            telaNombre:
              a.telas[0].codigo +
              " / " +
              a.telas[0].nombre +
              " / " +
              a.colores[0].name,
          };
        });
        let dataFinal = Object.values(tablaTelas);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["tela"] + item["color"];
          groups[val] = groups[val] || {
            tela: item.tela,
            color: item.color,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].tela = item.tela;
          groups[val].unidad = item.unidad;
          groups[val].color = item.color;
          groups[val].articulo = item.articulo;
          groups[val].telaNombre = item.telaNombre;
          return groups;
        }, []);

        let agrupadoValues = Object.values(agrupado);

        setInputFieldsAnterior(agrupadoValues);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_ARTICULOS_ORDENES_CORTE_EXTERNO}/orden/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .map((a) => {
            totalCantidad = totalCantidad + a.cantidad;
            totalCortado = totalCortado + a.cortado;
            totalPendCortar = totalPendCortar + a.pendiente_cortar;
            return {
              id: a._id,
              articuloNombre:
                a.articulos[0].codigo + " / " + a.articulos[0].descripcion,
              idArticulo: a.articulos[0]._id,
              cantidad: a.cantidad,
              cortado: a.cortado,
              pendiente_cortar: a.pendiente_cortar,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setArticulosOrden(data);

        let agrupado = data.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
          };
          groups[val].idArticulo = item.idArticulo;
          groups[val].articuloNombre = item.articuloNombre;
          return groups;
        }, []);
        let dataFinalAgru = Object.values(agrupado);
        setArticulosUnicos(dataFinalAgru);
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedOrdenCorte(id);
    setSelectedOrdenCorteNumero(numero);
    setTimeout(() => {
      toggleTelas();
      setModalProgreso(false);
    }, 2000);
  }

  function telasCortesDev(id, numero) {
    setIdsInventario([]);
    axios
      .get(`${URL_INVENTARIOS_TELAS}/cortesDevolucion/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTelasDevolucion = res.data;
        setTelasDevolucion(allTelasDevolucion);
        let result = allTelasDevolucion.map(({ _id }) => _id);
        setIdsInventario(result);
      })
      .catch((err) => {
        console.log(err);
      });
    setSelectedOrdenCorteDev(id);
    setSelectedOrdenCorteNumeroDev(numero);
    toggleTelasDev();
  }

  function BuscaRolloDev(id, event) {
    if (event.target.value.length >= 24) {
      if (idsInventario.includes(event.target.value)) {
        if (
          inputFields.filter((e) => e.idInventarioTelas == event.target.value)
            .length > 0
        ) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El rollo ya fue escaneado!",
            showConfirmButton: false,
          });
          const newInputFields = inputFields.map((i) => {
            if (id === i.id) {
              i.idInventarioTelas = "";
            }
            return i;
          });
          setInputFields(newInputFields);
        } else {
          telasDevolucion.map((a) => {
            if (a._id == event.target.value) {
              let telasDevolucion = a._id;
              let tela = a.tela;
              let idTela = a.idTela;
              let unidadTela = a.unidadTela;
              let color = a.color;
              let cantidadOriginal = a.cantidad;
              let cantidad = a.cantidad;
              let compras = a.compras;
              let telasOC = a.telasOC;
              let telaCodigo = a.telaCodigo;
              let telaNombre = a.telaNombre;
              let telaColor = a.telaColor;
              handleChangeInputArticuloDev(
                id,
                telasDevolucion,
                tela,
                idTela,
                unidadTela,
                color,
                cantidad,
                cantidadOriginal,
                compras,
                telasOC,
                telaCodigo,
                telaNombre,
                telaColor,
              );
            }
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El rollo no pertenece al pedido o fue devuelto previamente!",
          showConfirmButton: false,
        });
        const newInputFields = inputFields.map((i) => {
          if (id === i.id) {
            i.idInventarioTelas = "";
          }
          return i;
        });
        setInputFields(newInputFields);
      }
    } else {
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.idInventarioTelas = event.target.value;
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  }

  const handleChangeInputArticuloDev = (
    id,
    telasDevolucion,
    tela,
    idTela,
    unidadTela,
    color,
    cantidad,
    cantidadOriginal,
    compras,
    telasOC,
    telaCodigo,
    telaNombre,
    telaColor,
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idInventarioTelas = telasDevolucion;
        i.telas = tela;
        i.idTela = idTela;
        i.unidad = unidadTela;
        i.colores = color;
        i.cantidad = cantidad;
        i.cantidadOriginal = cantidadOriginal;
        i.compras = compras;
        i.telasOC = telasOC;
        i.telaCodigo = telaCodigo;
        i.telaNombre = telaNombre;
        i.telaColor = telaColor;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotalesDev();
    handleAddFields();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotalesDev();
  };

  function ActualizaTotalesDev() {
    let mts = inputFields.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = inputFields.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["colores"] + item["idTela"];
      groups[val] = groups[val] || {
        colores: item.colores,
        idTela: item.idTela,
        cantidad: 0,
      };
      groups[val].id = item.id;
      groups[val].cantidad += item.cantidad;
      groups[val].colores = item.colores;
      groups[val].idTela = item.idTela;
      return groups;
    }, []);

    let CA = Object.values(agrupado);
    setCantidadAgrupado(CA);

    let tr = 0;
    inputFields.map((a) => {
      if (a.idTela != "") {
        return (tr = tr + 1);
      }
    });
    setRollosTotalesDev(tr);
  }

  const saveTelasDev = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();

    let totalRollos = inputFields.length + cantidadAgrupado.length;

    try {
      inputFields.map((a) => {
        if (a.idInventarioTelas != "") {
          if (a.cantidad != a.cantidadOriginal) {
            axios
              .patch(
                `${URL_INVENTARIOS_TELAS}/${a.idInventarioTelas}`,
                {
                  cantidad:
                    parseFloat(a.cantidadOriginal) - parseFloat(a.cantidad),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token",
                    )}`,
                  },
                },
              )
              .then(() => {
                axios
                  .post(
                    `${URL_INVENTARIOS_TELAS}`,
                    {
                      cantidad: a.cantidad,
                      captura: 1,
                      produccion: "No",
                      telas: a.idTela,
                      colores: a.colores,
                      compras: a.compras,
                      telasOC: a.telasOC,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token",
                        )}`,
                      },
                    },
                  )
                  .then((data) => {
                    totalRollos = totalRollos - 1;
                    QRGen(
                      data.data._id,
                      a.telaCodigo,
                      a.telaNombre,
                      a.telaColor,
                      a.cantidad,
                      a.unidad,
                    );
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Crear Devolucion",
                            detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token",
                              )}`,
                            },
                          },
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          setTimeout(() => {
                            window.location.reload();
                          }, 1000);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          } else {
            axios
              .patch(
                `${URL_INVENTARIOS_TELAS}/devolucionCorte/${a.idInventarioTelas}`,
                {},
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token",
                    )}`,
                  },
                },
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Devolucion",
                        detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token",
                          )}`,
                        },
                      },
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        } else {
          totalRollos = totalRollos - 1;
          if (totalRollos == 0) {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Crear Devolucion",
                  detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token",
                    )}`,
                  },
                },
              )
              .then(() => {
                Swal.fire("Good job!", "Creado con exito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        }
      });

      // Pegamos a Devoluciones Acumulado

      cantidadAgrupado.map((w) => {
        if (w.idTela != "") {
          axios
            .patch(
              `${URL_INVENTARIOS_TELAS}DevolucionCorte2`,
              {
                ordenesCorte: selectedOrdenCorteDev,
                total_cantidad: w.cantidad,
                idColor: w.colores,
                idTela: w.idTela,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              },
            )
            .then(() => {
              totalRollos = totalRollos - 1;
              if (totalRollos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Devolucion",
                      detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token",
                        )}`,
                      },
                    },
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        } else {
          totalRollos = totalRollos - 1;
          if (totalRollos == 0) {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Crear Devolucion",
                  detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token",
                    )}`,
                  },
                },
              )
              .then(() => {
                Swal.fire("Good job!", "Creado con exito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        }
      });

      // Terminamos de post a devoluciones acumulado
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  function QRGen(id, codigo, nombre, color, cantidad, unidad) {
    // PDF 10 cm (ancho) x 5 cm (alto) horizontal
    const doc = new jsPDF("l", "mm", [100, 50]);

    // Márgenes y layout
    const M = 4;
    const PAGE_W = 100,
      PAGE_H = 50;
    const LEFT_COL_W = 60; // ancho de columna para texto
    const RIGHT_COL_X = M + LEFT_COL_W + 2;

    // Logos (arriba izquierda)
    try {
      const logo1 = new Image();
      logo1.src = process.env.PUBLIC_URL + "Logo-Lynqro-Negro.png";
      doc.addImage(logo1, "PNG", M, M, 22, 6);
    } catch (_) {}

    try {
      const logo2 = new Image();
      logo2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
      doc.addImage(logo2, "PNG", M, M + 7.5, 22, 8);
    } catch (_) {}

    // QR (arriba derecha)
    const base64 = qrcode.toDataURL(String(id ?? ""));
    const qrSize = 30;
    doc.addImage(base64, "PNG", RIGHT_COL_X, M, qrSize, qrSize);

    // Datos en vertical (columna izquierda)
    const wrap = (txt, maxW) => doc.splitTextToSize(String(txt ?? ""), maxW);
    let y = M + 20; // empieza debajo de los logos
    const step = 4;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(wrap(`Cod: ${codigo}`, LEFT_COL_W), M, y);
    y += step;
    doc.text(wrap(`Mod: ${nombre}`, LEFT_COL_W), M, y);
    y += step;
    doc.text(wrap(`Color: ${color}`, LEFT_COL_W), M, y);
    y += step;
    doc.text(wrap(`ID: ${id}`, LEFT_COL_W), M, y);
    y += step + 2;

    // Cantidad: debajo del QR (derecha), negrita, sin "Cant." (como ListadoCompras)
    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    const cantTxt = `${cantidad ?? ""} ${unidad ?? ""}`.trim();
    const qrCenterX = RIGHT_COL_X + 15;
    const cantY = M + 30 + 7;
    doc.text(cantTxt, qrCenterX, cantY, { align: "center" });

    // Descargar directamente
    // doc.save(`QR.pdf`);

    // O abrir en una pestaña nueva
    window.open(doc.output("bloburl"), "_blank");
  }

  let totalCantidadMt = 0;
  let totalCantidadKg = 0;
  async function PDFTelas(
    numero,
    fecha,
    pedido,
    id,
    total_piezas,
    cliente,
    articulo,
    // , patronista
  ) {
    let temp2 = [];
    await axios
      .get(`${URL_ARTICULOS_ORDENES_CORTE_EXTERNO}/orden/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async (response) => {
        let allArticulosOrdenCorte = response.data;
        let colorTallaCantidad = {};

        allArticulosOrdenCorte.forEach((a) => {
          const color = a.colores[0].name;
          const talla = a.tallas[0].name;
          const cantidad = a.cantidad;

          if (!colorTallaCantidad[talla]) {
            colorTallaCantidad[talla] = {};
          }
          if (!colorTallaCantidad[talla][color]) {
            colorTallaCantidad[talla][color] = 0;
          }
          colorTallaCantidad[talla][color] += cantidad;
        });

        const tallas = Object.keys(colorTallaCantidad).sort((a, b) => {
          const indexA = ordenTallas.indexOf(a);
          const indexB = ordenTallas.indexOf(b);

          // Si alguna talla no está en el orden definido, coloca al final
          return (
            (indexA === -1 ? Infinity : indexA) -
            (indexB === -1 ? Infinity : indexB)
          );
        });
        const colores = [
          ...new Set(allArticulosOrdenCorte.map((a) => a.colores[0].name)),
        ].sort();

        await axios
          .get(`${URL_INVENTARIOS_TELAS}/ordenCorte/${id}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(async (response) => {
            let allArticulosOrdenCorte = response.data;
            let arrayTabla = allArticulosOrdenCorte
              .map((a) => {
                if (a.unidad == "Metros") {
                  totalCantidadMt = totalCantidadMt + a.cantidad;
                } else {
                  totalCantidadKg = totalCantidadKg + a.cantidad;
                }
                return {
                  id: a._id,
                  articulo: a.articulo,
                  proveedor: a.proveedor,
                  factura: a.factura,
                  cantidad: a.cantidad,
                  cantidadSobrante: a.cantidadSobrante,
                  unidad: a.unidad,
                  idTela: a.idTela,
                  telaNombre: a.articulo,
                  colorNombre: a.colorNombre,
                  idColor: a.idColor,
                  cantidadString: a.cantidadString,
                  precio: a.precio,
                };
              })
              .filter(function (el) {
                return el != null;
              });

            let dataFinal = Object.values(arrayTabla);

            let mts = dataFinal.filter((e) => e.unidad == "Metros");
            let totalMts = mts.map((c) => parseFloat(c.cantidad));
            let TM = totalMts.reduce((t, total, index) => t + total, 0);

            let KG = dataFinal.filter((e) => e.unidad == "Kilos");
            let totalKG = KG.map((c) => parseFloat(c.cantidad));
            let TK = totalKG.reduce((t, total, index) => t + total, 0);

            const data = dataFinal
              .sort((a, b) => (a.colorNombre < b.colorNombre ? 1 : -1))
              .map((a) => {
                return [
                  a.proveedor,
                  a.articulo,
                  a.colorNombre,
                  "$" + new Intl.NumberFormat("en-US").format(a.precio),
                  a.factura,
                  new Intl.NumberFormat("en-US").format(a.cantidad) +
                    " " +
                    a.unidad,
                  new Intl.NumberFormat("en-US").format(
                    a.cantidad / total_piezas,
                  ),
                  new Intl.NumberFormat("en-US").format(a.cantidadSobrante),
                  a.cantidadString,
                ];
              });
            const dataPDF = Object.values(data);
            const dataPDFLimpia = dataPDF.filter(function (el) {
              return el != null;
            });
            // Observaciones de telas
            await axios
              .get(`${URL_TELAS_ORDENES_CORTE}/ordenCorte/${id}`, {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              })
              .then((response) => {
                let allObservacionesTela = response.data;
                // Array para pagination
                let observTela = allObservacionesTela
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return {
                      observaciones: a.observaciones,
                    };
                  })
                  .filter(function (el) {
                    return el != null;
                  });

                let dataFinalSobrante = Object.values(observTela);
                setObservacionesTelasPDF(dataFinalSobrante[0].observaciones);
              });

            // === Formato corporativo ===
            const doc = new jsPDF("landscape");
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const marginLeft = 15;
            const marginRight = 15;

            const brandColor = [42, 90, 138];
            const lightBg = [245, 247, 250];
            const borderColor = [210, 216, 224];
            const labelColor = [110, 120, 135];
            const stripeBg = [251, 252, 253];

            const drawLabel = (label, value, lblX, valX, y) => {
              doc.setFont(undefined, "bold");
              doc.setTextColor(...labelColor);
              doc.setFontSize(8.5);
              doc.text(label, lblX, y);
              doc.setFont(undefined, "normal");
              doc.setTextColor(0);
              doc.setFontSize(9.5);
              const txt = String(value ?? "").trim();
              doc.text(txt || "—", valX, y);
            };

            // Logo izquierda
            const imgLogo = new Image();
            imgLogo.src = process.env.PUBLIC_URL + "logoInstitucion.png";
            try {
              doc.addImage(imgLogo, "png", marginLeft, 8, 32, 14);
            } catch (e) {}

            // Título derecha + línea azul
            doc.setFont(undefined, "bold");
            doc.setFontSize(16);
            doc.setTextColor(...brandColor);
            doc.text(`SALIDA TELA OC # ${numero}`, pageWidth - marginRight, 18, {
              align: "right",
            });
            doc.setTextColor(0);
            doc.setDrawColor(...brandColor);
            doc.setLineWidth(0.6);
            doc.line(marginLeft, 28, pageWidth - marginRight, 28);
            doc.setLineWidth(0.2);
            doc.setDrawColor(0);

            // Card 2 columnas
            const cardY = 31;
            const cardW = pageWidth - marginLeft - marginRight;
            const cardH = 28;
            doc.setDrawColor(...borderColor);
            doc.setFillColor(...lightBg);
            doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
            doc.setDrawColor(0);

            const lblX_L = marginLeft + 3;
            const valX_L = marginLeft + 30;
            const baseY = cardY + 6;
            drawLabel("Fecha OC:", fecha, lblX_L, valX_L, baseY);
            drawLabel("Modelo:", articulo, lblX_L, valX_L, baseY + 5);
            drawLabel(
              "Cantidad:",
              `${totalCantidadMt.toFixed(2)} Mts ${totalCantidadKg.toFixed(2)} Kgs`,
              lblX_L,
              valX_L,
              baseY + 10,
            );
            drawLabel(
              "Observaciones:",
              observacionesTelasPDF,
              lblX_L,
              valX_L,
              baseY + 15,
            );

            const colRightX = pageWidth / 2 + 5;
            const lblX_R = colRightX;
            const valX_R = colRightX + 26;
            drawLabel("Pedido:", pedido, lblX_R, valX_R, baseY);
            drawLabel("Cliente:", cliente, lblX_R, valX_R, baseY + 5);
            drawLabel("Piezas:", total_piezas, lblX_R, valX_R, baseY + 10);

            // Crear una variable para almacenar todas las filas de datos
            const bodyData = [];

            // Iterar sobre las tallas
            tallas.forEach((talla) => {
              let rowData = [talla];
              let totalTalla = 0;

              // Iterar sobre los colores
              colores.forEach((color) => {
                const cantidad = colorTallaCantidad[talla][color] || 0;
                rowData.push(cantidad);
                totalTalla += cantidad;
              });

              // Agregar el total por talla al final de la fila
              rowData.push(totalTalla);

              // Agregar la fila de datos al conjunto de datos del cuerpo
              bodyData.push(rowData);
            });

            // Calcular y agregar totales por color en una fila al final de la tabla
            const totalesColorRow = ["Total"];
            let totalGeneral = 0; // Inicializar el total general
            colores.forEach((color) => {
              let totalColor = 0;
              tallas.forEach((talla) => {
                totalColor += colorTallaCantidad[talla][color] || 0;
              });
              totalesColorRow.push(totalColor);
              totalGeneral += totalColor; // Sumar al total general
            });

            // Agregar el total general al final de la fila de totales
            totalesColorRow.push(totalGeneral);

            // Agregar totalesColorRow al final de bodyData
            bodyData.push(totalesColorRow);

            // Generar la tabla con todos los datos del cuerpo y los estilos definidos fuera del bucle
            doc.autoTable({
              head: [["Tallas", ...colores, "Total"]],
              body: bodyData,
              startY: cardY + cardH + 5,
              margin: { left: marginLeft, right: marginRight },
              theme: "grid",
              styles: {
                fontSize: 9.5,
                cellPadding: 1,
                valign: "middle",
                halign: "center",
                lineColor: borderColor,
                lineWidth: 0.15,
              },
              headStyles: {
                fillColor: brandColor,
                textColor: [255, 255, 255],
                fontStyle: "bold",
                fontSize: 10,
                halign: "center",
              },
              alternateRowStyles: { fillColor: stripeBg },
            });

            doc.autoTable({
              head: [
                [
                  "Proveedor",
                  "Articulo",
                  "Color",
                  "Precio",
                  "Factura",
                  "Cantidad",
                  "Consumo",
                  "Sobrante",
                  "Rollos",
                ],
              ],
              body: dataPDFLimpia,
              startY: doc.autoTable.previous.finalY + 8,
              margin: { left: marginLeft, right: marginRight },
              foot: [[]],
              showFoot: "lastPage",
              theme: "grid",
              styles: {
                fontSize: 9,
                cellPadding: 1,
                valign: "middle",
                halign: "center",
                lineColor: borderColor,
                lineWidth: 0.15,
              },
              headStyles: {
                fillColor: brandColor,
                textColor: [255, 255, 255],
                fontStyle: "bold",
                fontSize: 9.5,
                halign: "center",
              },
              alternateRowStyles: { fillColor: stripeBg },
            });

            // ============ FOOTER — paginación ============
            try {
              const pageCount = doc.internal.getNumberOfPages();
              for (let p = 1; p <= pageCount; p++) {
                doc.setPage(p);
                doc.setFontSize(8);
                doc.setTextColor(...labelColor);
                doc.text(
                  `Salida Tela OC #${numero}  ·  ${cliente}  ·  Página ${p} de ${pageCount}`,
                  pageWidth / 2,
                  pageHeight - 5,
                  { align: "center" },
                );
                doc.setTextColor(0);
              }
            } catch (errFooter) {
              console.warn("No se pudo dibujar footer:", errFooter);
            }

            window.open(doc.output("bloburl"), "_blank");
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }

async function PDFTelasDetalles(
  numero,
  fecha,
  pedido,
  id,
  total_piezas,
  cliente,
  articulo,
) {
  try {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    // 1) Detalle de inventarios de telas
    const { data: allArticulosSurtido } = await axios.get(
      `${URL_INVENTARIOS_TELAS}/ordenCorteDetalle/${id}`,
      { headers },
    );

    const arrayTabla = (allArticulosSurtido || [])
      .map((a) => ({
        id: a?._id,
        articulo: a?.articulo,
        proveedor: a?.proveedor,
        factura: a?.factura,
        cantidad: Number(a?.cantidad || 0),
        cantidadSobrante: Number(a?.cantidadSobrante || 0),
        unidad: a?.unidad || "",
        idTela: a?.idTela,
        telaNombre: a?.articulo,
        colorNombre: a?.colorNombre,
        idColor: a?.idColor,
        cantidadString: a?.cant || "",
      }))
      .filter(Boolean);

    const dataFinal = Object.values(arrayTabla);

    // 🔥 Totales
    let totalCantidadMt = 0;
    let totalCantidadKg = 0;
    let totalCantidadGeneral = 0;

    for (const r of dataFinal) {
      totalCantidadGeneral += r.cantidad;

      if (String(r.unidad).toLowerCase().startsWith("metro"))
        totalCantidadMt += r.cantidad;
      else if (String(r.unidad).toLowerCase().startsWith("kilo"))
        totalCantidadKg += r.cantidad;
    }

    // 2) Observaciones y responsable
    let obsText = "";
    let responsableText = "";
    try {
      const { data: obsResp } = await axios.get(
        `${URL_TELAS_ORDENES_CORTE}/ordenCorte/${id}`,
        { headers },
      );

      const items = (obsResp || [])
        .sort((a, b) =>
          String(a?.nombre || "") > String(b?.nombre || "") ? 1 : -1,
        )
        .map((a) => ({
          observaciones: a?.observaciones || "",
          responsable: a?.responsable || "",
        }));

      const first = items[0] || {};
      obsText = first.observaciones || "";
      responsableText = first.responsable || "";
    } catch (e) {
      console.log("Error obteniendo observaciones/responsable:", e);
    }

    // 3) Tabla
    const dataPDFLimpia = dataFinal.map((a) => [
      a.id,
      a.telaNombre,
      a.colorNombre,
      `${new Intl.NumberFormat("en-US").format(a.cantidad)} ${a.unidad}`,
    ]);

    // === Formato corporativo ===
    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 15;
    const marginRight = 15;

    const brandColor = [42, 90, 138];
    const lightBg = [245, 247, 250];
    const borderColor = [210, 216, 224];
    const labelColor = [110, 120, 135];
    const stripeBg = [251, 252, 253];

    const drawLabel = (label, value, lblX, valX, y) => {
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8.5);
      doc.text(label, lblX, y);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9.5);
      const txt = String(value ?? "").trim();
      doc.text(txt || "—", valX, y);
    };

    // Logo izq
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    try {
      doc.addImage(img2, "png", marginLeft, 8, 32, 14);
    } catch (e) {}

    // Título der + línea azul
    doc.setFont(undefined, "bold");
    doc.setFontSize(16);
    doc.setTextColor(...brandColor);
    doc.text(`SALIDA TELA (ROLLOS) OC # ${numero}`, pageWidth - marginRight, 18, {
      align: "right",
    });
    doc.setTextColor(0);
    doc.setDrawColor(...brandColor);
    doc.setLineWidth(0.6);
    doc.line(marginLeft, 28, pageWidth - marginRight, 28);
    doc.setLineWidth(0.2);
    doc.setDrawColor(0);

    // Card 2 cols
    const cardY = 31;
    const cardW = pageWidth - marginLeft - marginRight;
    const cardH = 32;
    doc.setDrawColor(...borderColor);
    doc.setFillColor(...lightBg);
    doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
    doc.setDrawColor(0);

    const lblX_L = marginLeft + 3;
    const valX_L = marginLeft + 30;
    const baseY = cardY + 6;
    drawLabel("Fecha OC:", fecha, lblX_L, valX_L, baseY);
    drawLabel("Modelo:", articulo, lblX_L, valX_L, baseY + 5);
    drawLabel(
      "Cantidad:",
      `${totalCantidadMt.toFixed(2)} Mts ${totalCantidadKg.toFixed(2)} Kgs`,
      lblX_L,
      valX_L,
      baseY + 10,
    );
    drawLabel(
      "Total General:",
      new Intl.NumberFormat("en-US").format(totalCantidadGeneral),
      lblX_L,
      valX_L,
      baseY + 15,
    );
    drawLabel("Observaciones:", obsText, lblX_L, valX_L, baseY + 20);
    drawLabel("Responsable:", responsableText, lblX_L, valX_L, baseY + 25);

    const colRightX = pageWidth / 2 + 5;
    const lblX_R = colRightX;
    const valX_R = colRightX + 26;
    drawLabel("Pedido:", pedido, lblX_R, valX_R, baseY);
    drawLabel("Cliente:", cliente, lblX_R, valX_R, baseY + 5);
    drawLabel("Piezas:", total_piezas, lblX_R, valX_R, baseY + 10);

    doc.autoTable({
      head: [["id", "Tela", "Color", "Cantidad"]],
      body: dataPDFLimpia,
      startY: cardY + cardH + 5,
      margin: { left: marginLeft, right: marginRight },
      showFoot: "lastPage",
      foot: [
        [
          "",
          "",
          "TOTAL",
          new Intl.NumberFormat("en-US").format(totalCantidadGeneral),
        ],
      ],
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 1,
        valign: "middle",
        halign: "center",
        lineColor: borderColor,
        lineWidth: 0.15,
      },
      headStyles: {
        fillColor: brandColor,
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 9.5,
        halign: "center",
      },
      alternateRowStyles: {
        fillColor: stripeBg,
      },
      footStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineColor: [255, 255, 255],
        lineWidth: 0,
      },
      didParseCell: (h) => {
        if (h.section === "foot") {
          const isLastTwo = h.column.index === 2 || h.column.index === 3;
          if (isLastTwo) {
            h.cell.styles.fillColor = brandColor;
            h.cell.styles.textColor = [255, 255, 255];
            h.cell.styles.fontStyle = "bold";
            h.cell.styles.lineColor = brandColor;
            h.cell.styles.lineWidth = 0.15;
          } else {
            h.cell.styles.fillColor = [255, 255, 255];
            h.cell.styles.textColor = [255, 255, 255];
            h.cell.styles.lineColor = [255, 255, 255];
            h.cell.styles.lineWidth = 0;
          }
        }
      },
    });

    // ============ FOOTER — paginación ============
    try {
      const pageCount = doc.internal.getNumberOfPages();
      for (let p = 1; p <= pageCount; p++) {
        doc.setPage(p);
        doc.setFontSize(8);
        doc.setTextColor(...labelColor);
        doc.text(
          `Salida Tela (Rollos) OC #${numero}  ·  ${cliente}  ·  Página ${p} de ${pageCount}`,
          pageWidth / 2,
          pageHeight - 5,
          { align: "center" },
        );
        doc.setTextColor(0);
      }
    } catch (errFooter) {
      console.warn("No se pudo dibujar footer:", errFooter);
    }

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.log(err);
  }
}

  function BuscaRollo(id, event) {
    if (event.target.value.length >= 24) {
      if (inventarios.filter((e) => e._id == event.target.value).length > 0) {
        if (
          inputFields.filter((e) => e.idInventarioTelas == event.target.value)
            .length > 0
        ) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El rollo ya fue escaneado!",
            showConfirmButton: false,
          });
          const newInputFields = inputFields.map((i) => {
            if (id === i.id) {
              i.idInventarioTelas = "";
            }
            return i;
          });
          setInputFields(newInputFields);
        } else {
          inventarios.map((a) => {
            if (a._id == event.target.value) {
              let idInventarioTelas = a._id;
              let telas = a.telas[0].nombre;
              let idTela = a.telas[0]._id;
              let unidad = a.telas[0].unidad;
              let color = a.colores[0].name;
              let idColor = a.colores[0]._id;
              let cantidad = a.cantidad;
              let telaNombre = a.telas[0].nombre + " / " + a.colores[0].name;

              handleChangeInputTelas(
                id,
                idInventarioTelas,
                telas,
                idTela,
                unidad,
                color,
                idColor,
                cantidad,
                telaNombre,
              );
            }
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El rollo ya fue cortado previamente!",
          showConfirmButton: false,
        });
        const newInputFields = inputFields.map((i) => {
          if (id === i.id) {
            i.idInventarioTelas = "";
          }
          return i;
        });
        setInputFields(newInputFields);
      }
    } else {
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.idInventarioTelas = event.target.value;
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  }

  const handleChangeInputTelas = (
    id,
    idInventarioTelas,
    telas,
    idTela,
    unidad,
    color,
    idColor,
    cantidad,
    telaNombre,
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idInventarioTelas = idInventarioTelas;
        i.telas = telas;
        i.idTela = idTela;
        i.unidad = unidad;
        i.colores = color;
        i.idColor = idColor;
        i.cantidad = cantidad;
        i.telaNombre = telaNombre;
      }
      return i;
    });

    ActualizaTotalesSurt();
    setInputFields(newInputFields);
    handleAddFields();
  };

  function ActualizaTotalesSurt() {
    let mts = inputFields.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = inputFields.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["idArticulo"] + item["idColor"] + item["idTela"];
      groups[val] = groups[val] || {
        idArticulo: item.idArticulo,
        idColor: item.idColor,
        idTela: item.idTela,
        cantidad: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val].telas = item.telas;
      groups[val].idTela = item.idTela;
      groups[val].idArticulo = item.idArticulo;
      groups[val].unidad = item.unidad;
      groups[val].idColor = item.idColor;
      return groups;
    }, []);

    let CA = Object.values(agrupado);
    setCantidadAgrupado(CA);
    let tr = 0;
    inputFields.map((a) => {
      if (a.idArticulo != "") {
        return (tr = tr + 1);
      }
    });
    setRollosTotales(tr);
  }

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];

    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        idInventarioTelas: "",
        telas: "",
        idTela: "",
        unidad: "",
        colores: "",
        idColor: "",
        cantidad: 0,
        idArticulo: ultimo.idArticulo,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1,
    );
    setInputFields(values);
    let mts = values.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = values.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);
  };

  const handleChangeInputArticulo = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idArticulo = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  const saveTelas = async (event) => {
    event.preventDefault();
    if (fechaTelas != "" && observacionesTelas != "") {
      setValidaBoton(false);
      toggleProgreso();

      let totalRollos = inputFields.length + cantidadAgrupado.length;
      try {
        await axios
          .post(
            URL_TELAS_ORDENES_CORTE,
            {
              fecha: fechaTelas,
              ordenesCorte: selectedOrdenCorte,
              observaciones: observacionesTelas,
              totalMetros,
              totalKilos,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            },
          )
          .then((data) => {
            inputFields.map((a) => {
              if (a.idTela != "") {
                axios
                  .patch(
                    `${URL_INVENTARIOS_TELAS}/ordenesCorte/${a.idInventarioTelas}`,
                    {
                      ordenesCorte: selectedOrdenCorte,
                      fechaCorte: fechaTelas,
                      produccion: "Si",
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token",
                        )}`,
                      },
                    },
                  )
                  .then(() => {
                    totalRollos = totalRollos - 1;
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Crear Telas Ordenes Compra",
                            detalle: `Ordenes Compra ${selectedOrdenCorteNumero}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token",
                              )}`,
                            },
                          },
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          setTimeout(() => {
                            window.location.reload();
                          }, 1000);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  });
              } else {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Telas Ordenes Compra",
                        detalle: `Ordenes Compra ${selectedOrdenCorteNumero}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token",
                          )}`,
                        },
                      },
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              }
            });

            // Pegamos a Apartados Acumulado

            cantidadAgrupado.map((w) => {
              axios
                .post(
                  `${URL_TELAS_ORDENES_CORTES_ACUMULADOS}`,
                  {
                    telasOrdenesCorte: data.data._id,
                    articulos: w.idArticulo,
                    telas: w.idTela,
                    colores: w.idColor,
                    cantidad: w.cantidad,
                    ordenesCorte: selectedOrdenCorte,
                    fecha: fechaTelas,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token",
                      )}`,
                    },
                  },
                )
                .then(() => {
                  totalRollos = totalRollos - 1;
                  if (totalRollos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Telas Ordenes Compra",
                          detalle: `Ordenes Compra ${selectedOrdenCorteNumero}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token",
                            )}`,
                          },
                        },
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            });

            // Terminamos de post a apartados acumulado
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };

  function cortado(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se marcará como cortado!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Marcar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ORDENES_CORTE_EXTERNO}/${id}`,
            {
              cortado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            },
          )
          .then(() => {
            const newComments = comments.map((i) => {
              if (id === i._id) {
                i.cortado = "Si";
              }
              return i;
            });
            setComments(newComments);

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Cerró",
              showConfirmButton: false,
              timer: 1000,
            });

            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function noCortado(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se marcará como no cortado!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Marcar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ORDENES_CORTE_EXTERNO}/${id}`,
            {
              cortado: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            },
          )
          .then(() => {
            const newComments = comments.map((i) => {
              if (id === i._id) {
                i.cortado = "No";
              }
              return i;
            });
            setComments(newComments);

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Abrió",
              showConfirmButton: false,
              timer: 1000,
            });

            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  // L113 — carga (o recarga) las filas del modal Editar para una orden de corte externo
  async function cargarArticulosEdit(id) {
    const { data: allArticulos } = await axios.get(
      `${URL_ARTICULOS_ORDENES_CORTE_EXTERNO}/orden/${id}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );
    const array = allArticulos.map((a) => ({
      _id: a._id,
      cantidad: a.cantidad,
      cortado: a.cortado,
      pendiente_cortar: a.pendiente_cortar,
      articulo: a.articulos[0].codigo + " " + a.articulos[0].descripcion,
      idArticulo: a.articulos[0]._id,
      color: a.colores[0].name,
      idColor: a.colores[0]._id,
      tallaName: a.tallas[0].name,
      talla:
        a.tallas[0].name +
        (a.tallas[0].variantesTallas?.[0]?.name
          ? " " + a.tallas[0].variantesTallas[0].name
          : ""),
      idTalla: a.tallas[0]._id,
      precio: a.precio,
      areasCliente: a.areasClientes[0].name,
      // L113 — área y pedido para heredar al agregar nuevas combinaciones
      idArea: a.areasClientes?.[0]?._id || a.areasClientes?.[0] || "",
      idPedido: a.pedidos?.[0]?._id || a.pedidos?.[0] || "",
    }));
    setArticulosEdit(array);
    const TM = array.reduce((t, c) => t + parseFloat(c.cantidad || 0), 0);
    setTotalPiezas(TM);
    const TG = array.reduce(
      (t, c) => t + (parseFloat(c.cantidad || 0) * parseFloat(c.precio || 0)),
      0
    );
    setTotalGeneral(TG);
    return array;
  }

  // L124 — cargar artículos del PEDIDO de la orden (para agregar uno distinto que esté en el pedido)
  async function cargarArticulosDelPedido(idPedido) {
    if (!idPedido) {
      setArticulosPedidoEdit([]);
      return;
    }
    try {
      const URL_AP = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
      const { data } = await axios.get(`${URL_AP}/pedidos/${idPedido}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      // único por artículo, guardando su área y pedido (para heredarlos al agregar)
      const map = new Map();
      (data || []).forEach((ap) => {
        const art = ap.articulos?.[0];
        const idArt = art?._id || art;
        if (!idArt || map.has(String(idArt))) return;
        map.set(String(idArt), {
          id: String(idArt),
          nombre: `${art?.codigo || ""} ${art?.descripcion || ""}`.trim(),
          idArea: ap.areasClientes?.[0]?._id || ap.areasClientes?.[0] || "",
          idPedido: ap.pedidos?.[0]?._id || ap.pedidos?.[0] || idPedido,
        });
      });
      setArticulosPedidoEdit([...map.values()]);
    } catch (e) {
      console.log(e);
      setArticulosPedidoEdit([]);
    }
  }

  // (2026-08) Autorizada => no se pueden modificar los artículos
  const estaAutorizada = (a) => String(a?.autorizacionVarios || "No") === "Si";

  async function jalaEdit(id, numero, totalGeneral, observaciones) {
    const orden = (comments || []).find((x) => x._id === id);
    if (estaAutorizada(orden)) {
      return Swal.fire(
        "Orden autorizada",
        "No se pueden modificar los artículos de una orden autorizada.",
        "warning"
      );
    }
    setIdEdit(id);
    setTotalGeneral(totalGeneral);
    setObservacionesEdit(observaciones);
    // L113 — limpiar formulario de "agregar"
    setAgregarArticulo("");
    setAgregarTallas([]);
    setAgregarColores([]);
    setAgregarTalla("");
    setAgregarColor("");
    setAgregarCantidad("");
    setAgregarPrecio("");
    try {
      await cargarTodosColores(); // todos los colores del catálogo
      // (2026-07) catálogo de tallas (con variantes) para poder editar la Talla
      try {
        const { data: tallasCat } = await axios.get(URL_TALLAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        });
        const norm = (x) => String(x || "").trim().toUpperCase();
        const arr = (Array.isArray(tallasCat) ? tallasCat : []).slice().sort((a, b) => {
          const na = norm(a.name);
          const nb = norm(b.name);
          if (na !== nb)
            return na.localeCompare(nb, "es", { numeric: true, sensitivity: "base" });
          const va = a.variantesTallas?.[0]?.name || "";
          const vb = b.variantesTallas?.[0]?.name || "";
          return va.localeCompare(vb, "es", { sensitivity: "base" });
        });
        setTallasEdit(arr);
      } catch (eT) {
        console.log("No se pudo cargar catálogo de tallas:", eT);
      }
      const array = await cargarArticulosEdit(id);
      // L124 — artículos del pedido de la orden (para poder agregar uno distinto del pedido)
      const idPedidoOrden = array.find((r) => r.idPedido)?.idPedido || "";
      await cargarArticulosDelPedido(idPedidoOrden);
      // Si solo hay un artículo en la orden, preseleccionarlo y cargar su catálogo
      const unicos = [...new Set(array.map((r) => r.idArticulo))];
      if (unicos.length === 1) {
        await cargaCatalogoArticuloAgregar(unicos[0]);
      }
      toggleEdit();
    } catch (err) {
      console.log(err);
    }
  }

  // L113 — al elegir artículo, traer su catálogo de tallas (colores = todo el catálogo)
  async function cargaCatalogoArticuloAgregar(idArticulo) {
    setAgregarArticulo(idArticulo);
    setAgregarTalla("");
    if (!idArticulo) {
      setAgregarTallas([]);
      return;
    }
    try {
      const { data } = await axios.get(`${URL_ARTICULOS}/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      setAgregarTallas(data?.tallas || []);
    } catch (e) {
      console.log(e);
    }
  }

  // L113 — cargar TODO el catálogo de colores (ordenado alfabéticamente)
  async function cargarTodosColores() {
    try {
      const { data } = await axios.get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      const colores = Array.isArray(data) ? [...data] : [];
      colores.sort((a, b) =>
        (a?.name || "").localeCompare(b?.name || "", "es", {
          sensitivity: "base",
        })
      );
      setAgregarColores(colores);
    } catch (e) {
      console.log(e);
    }
  }

  // ==========================================================================
  // (2026-07) CONSUMOS DE TELAS por pedido — portado idéntico de ListadoPedidos.
  // La orden de corte externo se liga a un pedido, así que abrimos los mismos
  // consumos (por artículo + color) para ese pedido.
  // ==========================================================================
  // (2026-10) El modal (ConsumosTelasModal, compartido con ListadoPedidos)
  // carga y guarda sus propios datos; aquí sólo se abre con el pedido.
  async function ConsumoTelas(idPedidoConsumo, numeroPedidoConsumo, cliente) {
    setConsumoIdPedido(idPedidoConsumo);
    setConsumoNumeroPedido(numeroPedidoConsumo);
    setConsumoCliente(cliente);
    setModalConsumos(true);
    // el PDF de consumos busca aquí el nombre del color si viene sin poblar
    if (!coloresConsumo.length) {
      axios
        .get(URL_COLORES, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        })
        .then((r) => setColoresConsumo(Array.isArray(r.data) ? r.data : []))
        .catch(() => {});
    }
  }

  async function PDFConsumosPorArticulo(numeroPedido, clienteNombre, idPedido) {
    try {
      const headers = {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      };
      const { data: consumosPDF } = await axios.get(
        `${URL_CONSUMO_TELAS}Pedido/${idPedido}`,
        { headers }
      );
      if (!consumosPDF.length) {
        return Swal.fire(
          "Sin consumos",
          "No hay consumos para este pedido",
          "info"
        );
      }
      const { data: articulosPedido } = await axios.get(
        `${URL_ARTICULOS_PEDIDO}/pedidos/${idPedido}`,
        { headers }
      );

      const cantidadesPorArticuloColor = {};
      articulosPedido.forEach((ap) => {
        const articuloId = ap.articulos?.[0]?._id || ap.articulos;
        const colorId = ap.colores?.[0]?._id || ap.colores;
        if (articuloId && colorId) {
          const key = `${articuloId}|${colorId}`;
          cantidadesPorArticuloColor[key] =
            (cantidadesPorArticuloColor[key] || 0) + (ap.cantidad || 0);
        }
      });

      const agrupado = {};
      consumosPDF.forEach((c) => {
        if ((c.cantidad || 0) <= 0) return;
        const articuloRaw = Array.isArray(c.articulos)
          ? c.articulos[0]
          : c.articulos;
        const telaRaw = Array.isArray(c.telas) ? c.telas[0] : c.telas;
        const colorRaw = Array.isArray(c.colores) ? c.colores[0] : c.colores;
        if (!articuloRaw) return;
        const articuloId =
          typeof articuloRaw === "object" ? articuloRaw._id : articuloRaw;
        if (!articuloId) return;
        const articuloNombre =
          typeof articuloRaw === "object"
            ? `${articuloRaw.codigo || ""} ${
                articuloRaw.descripcion || ""
              }`.trim()
            : "Articulo sin nombre";
        const telaNombre =
          typeof telaRaw === "object"
            ? telaRaw.nombre || "Sin nombre"
            : telaRaw || "Sin nombre";
        const ancho = typeof telaRaw === "object" ? telaRaw.ancho || "NA" : "NA";
        let colorNombre = "NA";
        if (colorRaw) {
          if (typeof colorRaw === "object") colorNombre = colorRaw.name || "NA";
          else
            colorNombre =
              coloresConsumo.find((cc) => cc._id === colorRaw)?.name || "NA";
        }
        const colorTelaRaw = Array.isArray(c.coloresTela)
          ? c.coloresTela[0]
          : c.coloresTela;
        let colorTelaNombre = "NA";
        if (colorTelaRaw) {
          if (typeof colorTelaRaw === "object")
            colorTelaNombre = colorTelaRaw.name || "NA";
          else
            colorTelaNombre =
              coloresConsumo.find((cc) => cc._id === colorTelaRaw)?.name || "NA";
        }
        const colorIdMult = colorRaw
          ? typeof colorRaw === "object"
            ? colorRaw._id
            : colorRaw
          : "";
        const cantidadColor =
          cantidadesPorArticuloColor[`${articuloId}|${colorIdMult}`] || 0;
        const clave = articuloId.toString();
        if (!agrupado[clave]) {
          agrupado[clave] = { nombre: articuloNombre, consumos: [] };
        }
        agrupado[clave].consumos.push({
          color: colorNombre,
          tela: telaNombre,
          colorTela: colorTelaNombre,
          cantidad: c.cantidad || 0,
          observaciones: c.observaciones?.trim() || "NA",
          ancho,
          cantidadColor,
        });
      });

      const doc = new jsPDF();
      const img = new Image();
      img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
      doc.addImage(img, "png", 165, 10, 25, 7.5);
      const img2 = new Image();
      img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
      doc.addImage(img2, "png", 165, 18, 25, 14);
      doc.setFontSize(12);
      doc.text(`Consumos del Pedido #${numeroPedido}`, 20, 20);
      doc.text(`Cliente: ${clienteNombre}`, 20, 27);
      doc.setFontSize(10);

      let currentY = 35;
      for (const idArticulo in agrupado) {
        const grupo = agrupado[idArticulo];
        doc.setFont(undefined, "bold");
        doc.text(`Modelo: ${grupo.nombre}`, 20, currentY);
        currentY += 6;
        const body = grupo.consumos.map((c) => {
          const totalConsumo = (c.cantidad || 0) * (c.cantidadColor || 0);
          return [
            c.color,
            c.tela,
            c.colorTela,
            c.ancho,
            c.cantidad,
            c.cantidadColor,
            totalConsumo.toFixed(2),
            c.observaciones,
          ];
        });
        const totalArticulo = grupo.consumos.reduce(
          (sum, c) => sum + (c.cantidad || 0) * (c.cantidadColor || 0),
          0
        );
        body.push([
          {
            content: "Total",
            colSpan: 6,
            styles: { halign: "right", fontStyle: "bold" },
          },
          totalArticulo.toFixed(2),
          "",
        ]);
        doc.autoTable({
          head: [
            [
              "Color",
              "Tela",
              "Color Tela",
              "Ancho",
              "Consumo Unitario",
              "Cantidad Color",
              "Total",
              "Observaciones",
            ],
          ],
          body,
          startY: currentY,
          styles: { fontSize: 10, halign: "center" },
          headStyles: {
            fillColor: [41, 128, 186],
            textColor: [255, 255, 255],
            fontStyle: "bold",
          },
        });
        currentY = doc.autoTable.previous.finalY + 10;
        if (currentY > 260) {
          doc.addPage();
          currentY = 20;
        }
      }
      window.open(doc.output("bloburl"), "_blank");
    } catch (err) {
      console.error("Error generando PDF de consumos:", err);
      Swal.fire("Error", "No se pudo generar el PDF de consumos", "error");
    }
  }

  // L113 — agregar una combinación talla/color del mismo artículo a la orden de corte externo
  async function agregarTallaColor() {
    const cant = parseFloat(agregarCantidad);
    const prec = parseFloat(agregarPrecio);
    if (
      !agregarArticulo ||
      !agregarTalla ||
      !agregarColor ||
      !(cant > 0) ||
      !(prec >= 0)
    ) {
      Swal.fire(
        "Faltan datos",
        "Selecciona artículo, talla, color, cantidad (>0) y precio.",
        "warning"
      );
      return;
    }
    const base = articulosEdit.find(
      (r) => String(r.idArticulo) === String(agregarArticulo)
    );
    // L124 — si el artículo no está en la orden, heredar área/pedido del pedido
    const apBase = articulosPedidoEdit.find(
      (r) => String(r.id) === String(agregarArticulo)
    );
    const idAreaFinal = base?.idArea || apBase?.idArea || "";
    const idPedidoFinal = base?.idPedido || apBase?.idPedido || "";
    if (!idAreaFinal || !idPedidoFinal) {
      Swal.fire(
        "Error",
        "No se pudo heredar el área/pedido del artículo.",
        "error"
      );
      return;
    }
    const dup = articulosEdit.some(
      (r) =>
        String(r.idArticulo) === String(agregarArticulo) &&
        String(r.idTalla) === String(agregarTalla) &&
        String(r.idColor) === String(agregarColor)
    );
    if (dup) {
      Swal.fire(
        "Ya existe",
        "Esa combinación talla/color ya está en la orden. Edita su cantidad arriba.",
        "warning"
      );
      return;
    }
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    try {
      await axios.post(
        URL_ARTICULOS_ORDENES_CORTE_EXTERNO,
        {
          ordenesCorteExterno: idEdit,
          pedidos: idPedidoFinal,
          articulos: agregarArticulo,
          colores: agregarColor,
          tallas: agregarTalla,
          areasClientes: idAreaFinal,
          cantidad: cant,
          cortado: 0,
          pendiente_cortar: cant,
          precio: prec,
        },
        { headers }
      );
      // Recargar filas y actualizar totales del header de la orden
      const rows = await cargarArticulosEdit(idEdit);
      const nuevoTotalPiezas = rows.reduce(
        (t, c) => t + parseFloat(c.cantidad || 0),
        0
      );
      const nuevoTotalGeneral = rows.reduce(
        (t, c) => t + parseFloat(c.cantidad || 0) * parseFloat(c.precio || 0),
        0
      );
      await axios.patch(
        `${URL_ORDENES_CORTE_EXTERNO}/${idEdit}`,
        { cantidad: nuevoTotalPiezas, totalGeneral: nuevoTotalGeneral },
        { headers }
      );
      setAgregarTalla("");
      setAgregarColor("");
      setAgregarCantidad("");
      setAgregarPrecio("");
      Swal.fire("Agregado", "Talla/color agregado a la orden.", "success");
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo agregar la talla/color.",
        footer: `${err?.response?.data?.error || ""}`,
      });
    }
  }

  // L113 — artículos únicos de la orden (solo se puede agregar uno que YA está)
  const articulosUnicosEdit = [
    ...new Map(
      articulosEdit.map((r) => [r.idArticulo, { id: r.idArticulo, nombre: r.articulo }])
    ).values(),
  ];

const sortedArticulosEdit = [...articulosEdit].sort((a, b) => {
  // 1. Ordenar por areasCliente
  const areaA = a.areasCliente?.name || a.areasCliente?.[0]?.name || a.areasCliente || "";
  const areaB = b.areasCliente?.name || b.areasCliente?.[0]?.name || b.areasCliente || "";

  if (areaA > areaB) return 1;
  if (areaA < areaB) return -1;

  // 2. Ordenar por articulo
  const artA = a.articulo?.name || a.articulo?.[0]?.name || a.articulo || "";
  const artB = b.articulo?.name || b.articulo?.[0]?.name || b.articulo || "";

  if (artA > artB) return 1;
  if (artA < artB) return -1;

  // 3. Ordenar por color
  if (a.color > b.color) return 1;
  if (a.color < b.color) return -1;

  // 4. Ordenar por talla (orden personalizado)
  const indexA = ordenTallas.indexOf(a.tallaName);
  const indexB = ordenTallas.indexOf(b.tallaName);

  if (indexA !== -1 && indexB !== -1) {
    return indexA - indexB;
  }

  if (indexA === -1) return 1;
  if (indexB === -1) return -1;

  return 0;
});

const handleChangeInputEdit = (id, event) => {
  const { name, value } = event.target;

  const newArticulosEdit = articulosEdit.map((i) => {
    if (id === i._id) {
      return {
        ...i,
        [name]: value === "" ? "" : parseFloat(value),
      };
    }
    return i;
  });

  setArticulosEdit(newArticulosEdit);
  ActualizaTotales(newArticulosEdit);
};

// (2026-07) editar la Talla de un renglón (talla es ObjectId, no número)
const handleChangeTallaEdit = (id, value) => {
  const t = tallasEdit.find((x) => String(x._id) === String(value));
  const display = t
    ? `${t.name}${
        t.variantesTallas?.[0]?.name ? " " + t.variantesTallas[0].name : ""
      }`
    : "";
  setArticulosEdit((prev) =>
    prev.map((i) =>
      i._id === id ? { ...i, idTalla: value, talla: display, tallaName: t?.name || i.tallaName } : i
    )
  );
};

function ActualizaTotales(data = articulosEdit) {
  let TM = data.reduce((acc, c) => acc + (parseFloat(c.cantidad) || 0), 0);

  let TG = data.reduce(
    (acc, c) =>
      acc + ((parseFloat(c.cantidad) || 0) * (parseFloat(c.precio) || 0)),
    0
  );

  setTotalPiezas(TM);
  setTotalGeneral(TG);
}

async function saveEdit() {
  let tot = articulosEdit.length;

  await axios
    .patch(
      `${URL_ORDENES_CORTE_EXTERNO}/${idEdit}`,
      {
        cantidad: total_piezas,
        totalGeneral,
        observaciones: observacionesEdit,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then(() => {
      articulosEdit.map((a) => {
        axios
          .patch(
            `${URL_ARTICULOS_ORDENES_CORTE_EXTERNO}/${a._id}`,
            {
              cantidad: a.cantidad,
              pendiente_cortar: a.cantidad,
              precio: a.precio,
              // (2026-07) guardar la talla editada
              ...(a.idTalla ? { tallas: a.idTalla } : {}),
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            tot = tot - 1;
            if (tot == 0) {
              Swal.fire("Good job!", "Editado con exito", "success");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    })
    .catch((err) => {
      console.log(err);
    });
}

  function jalaHabilitacion(id, idArticulo, idPedido, idCorte) {
    setIdProcesosSalidaHab(id);
    setIdCorteHab(idCorte);
    setIdPedidoHab(idPedido);

    // (2026-07) En órdenes de corte EXTERNO la fila no trae un idArticulo único
    // (la orden puede tener varios artículos). Si no hay artículo, NO consultamos
    // la explosión (evita el CastError "articulos: undefined" en el backend) y
    // abrimos el modal con una fila vacía para capturar el material a mano.
    if (!idArticulo) {
      setInputFieldsHabilitacion([
        { id: uuidv4(), idHabilitacion: "", cantidad: 0 },
      ]);
      toggleHabilitacion();
      return;
    }

    axios
      .get(`${URL_EXPLOSION}Articulo/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .sort((a, b) => (a.idProcesosSalida < b.idProcesosSalida ? 1 : -1))
          .map((a) => {
            return {
              id: uuidv4(),
              idHabilitacion: a.habilitacion[0]._id,
              // nombre: a.habilitacion[0].nombre + " " + a.habilitacion[0].descripcion,
              // cantidadAnterior: a.cantidad,
              cantidad: 0,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setInputFieldsHabilitacion(data);
      })
      .catch((err) => {
        console.log(err);
      });

    toggleHabilitacion();
  }

  function saveHabilitacion(event) {
    event.preventDefault();
    let totalRollos = inputFieldsHabilitacion.length;
    axios
      .post(
        URL_HABILITACION_ORDENES_CORTES,
        {
          ordenesCorte: idCorteHab,
          pedidos: idPedidoHab,
          fecha: fechaHab,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      )
      .then((data2) => {
        inputFieldsHabilitacion.map((a) => {
          if (a.cantidad != 0) {
            axios
              .post(
                URL_DETALLE_HABILITACION_ORDENES_CORTES,
                {
                  cantidad: a.cantidad,
                  habilitacionOrdenesCortes: data2.data._id,
                  ordenesCorte: idCorteHab,
                  pedidos: idPedidoHab,
                  habilitacion: a.idHabilitacion,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token",
                    )}`,
                  },
                },
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Salida de Habilitacion",
                        detalle: `Pedido ${idPedidoHab}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token",
                          )}`,
                        },
                      },
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              });
          } else {
            totalRollos = totalRollos - 1;
            if (totalRollos == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Salida de Habilitacion",
                    detalle: `Pedido ${idPedidoHab}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token",
                      )}`,
                    },
                  },
                )
                .then(() => {
                  Swal.fire("Good job!", "Creado con exito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            }
          }
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
        setValidaBoton(true);
      });
  }

  const handleChangeInputHabilitacion = (id, event) => {
    const newInputFieldsHabilitacion = inputFieldsHabilitacion.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsHabilitacion(newInputFieldsHabilitacion);
  };

  const handleRemoveFieldsHabilitaccion = (id) => {
    const values = [...inputFieldsHabilitacion];
    values.splice(
      values.findIndex((value) => value.id === id),
      1,
    );
    setInputFieldsHabilitacion(values);
  };

  const handleAddFieldsHabilitacion = () => {
    setInputFieldsHabilitacion([
      ...inputFieldsHabilitacion,
      {
        id: uuidv4(),
        idHabilitacion: "",
        cantidad: 0,
      },
    ]);
  };

  function jalaHabilitacionEdit(id) {
    axios
      .get(`${URL_DETALLE_HABILITACION_ORDENES_CORTES}/proceso/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .sort((a, b) => (a.idProcesosSalida < b.idProcesosSalida ? 1 : -1))
          .map((a) => {
            return {
              id: a._id,
              idHabilitacion: a.habilitacion[0]._id,
              nombre:
                a.habilitacion[0].nombre + " " + a.habilitacion[0].descripcion,
              cantidadAnterior: a.cantidad,
              cantidad: a.cantidad,
              observaciones: a.habilitacionOrdenesCortes[0].observaciones,
            };
          })
          .filter((el) => el != null);

        const data = Object.values(arrayTabla);
        setEditHab(data);

        if (data.length > 0) {
          setObservacionesHab(data[0].observaciones);
        }

        toggleEditHab();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleChangeInputHabilitacionEdit = (id, event) => {
    const newInputFieldsHabilitacion = editHab.map((i) => {
      if (id === i.id) {
        i.cantidad = parseFloat(event.target.value);
      }
      return i;
    });
    setEditHab(newInputFieldsHabilitacion);
  };

  function saveHabilitacionEdit(event) {
    event.preventDefault();
    let totalRollos = editHab.length;
    editHab.map((a) => {
      axios
        .patch(
          `${URL_DETALLE_HABILITACION_ORDENES_CORTES}/${a.id}`,
          {
            habilitacion: a.idHabilitacion,
            cantidad: a.cantidad,
            cantidadAnterior: a.cantidadAnterior,
            observaciones: observacionesHab,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          },
        )
        .then(() => {
          totalRollos = totalRollos - 1;
          if (totalRollos == 0) {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Editar Salida de Habilitacion",
                  detalle: `Pedido`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token",
                    )}`,
                  },
                },
              )
              .then(() => {
                Swal.fire("Good job!", "Creado con exito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        });
    });
  }

  async function PDFOCHab(
    numero,
    cliente,
    fecha,
    pedido,
    idPedidos,
    articuloCodigo,
    articuloDescripcion,
    idArticulo,
    totalPiezas,
    observaciones,
    idPDFOC,
  ) {
    const getImageAsDataURL = (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL("image/png"));
          } catch (e) {
            reject(e);
          }
        };
        img.onerror = reject;
        img.src = url;
      });
    };

    try {
      const { data: allArticulosOrdenCorte } = await axios.get(
        `${URL_ARTICULOS_ORDENES_CORTE_EXTERNO}/orden/${idPDFOC}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      );

      const doc = new jsPDF();
      const logo = new Image();
      logo.src = process.env.PUBLIC_URL + "logoInstitucion.png";

      await new Promise((resolve) => {
        logo.onload = () => {
          const scale = 30 / logo.height;
          doc.addImage(
            logo,
            "png",
            (doc.internal.pageSize.getWidth() - logo.width * scale) / 2,
            10,
            logo.width * scale,
            logo.height * scale,
          );
          resolve();
        };
      });

      doc.setFontSize(12);
      doc.text(`Orden de Produccion # ${numero}, Fecha ${fecha}`, 15, 50);
      doc.text(`Pedido ${pedido}, Cliente ${cliente}`, 15, 55);
      doc.text(`Observaciones ${observaciones}`, 15, 60);
      doc.text(`Modelo ${articuloCodigo} ${articuloDescripcion}`, 15, 65);
      let currentY = 80;

      const grupoPorSucursalAreaArticulo = {};
      allArticulosOrdenCorte.forEach((a) => {
        const sucursal = a.sucursales?.[0]?.alias || "Sin Sucursal";
        const area = a.areasClientes?.[0]?.name || "Sin Área";
        const articulo = a.articulos?.[0]?.descripcion || "Sin Artículo";
        const clave = `${sucursal}||${area}||${articulo}`;
        if (!grupoPorSucursalAreaArticulo[clave])
          grupoPorSucursalAreaArticulo[clave] = [];
        grupoPorSucursalAreaArticulo[clave].push(a);
      });

      for (const clave in grupoPorSucursalAreaArticulo) {
        const grupo = grupoPorSucursalAreaArticulo[clave];
        const [sucursal, area, articulo] = clave.split("||");

        doc.setFontSize(11);
        doc.setFont(undefined, "bold");
        doc.text(`Sucursal: ${sucursal}`, 20, currentY);
        currentY += 6;
        doc.text(`Área: ${area}`, 20, currentY);
        currentY += 6;
        doc.text(`Modelo: ${articulo}`, 20, currentY);
        currentY += 6;

        const agrupadoPorColor = {};
        const tallasSet = new Set();

        grupo.forEach((a) => {
          const color = a.colores?.[0]?.name || "Sin Color";
          const talla = a.tallas?.[0]?.name?.trim() || "Sin Talla";
          const variante =
            a.tallas?.[0]?.variantesTallas[0]?.name?.trim() || "";
          const key = talla;
          const detalle = variante ? `(${variante})` : "";

          if (!agrupadoPorColor[color]) agrupadoPorColor[color] = {};
          if (!agrupadoPorColor[color][key]) agrupadoPorColor[color][key] = [];
          agrupadoPorColor[color][key].push({ cantidad: a.cantidad, detalle });
          tallasSet.add(key);
        });

        const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];
        const tallas = Array.from(tallasSet).sort((a, b) => {
          const indexA = ordenTallas.indexOf(a);
          const indexB = ordenTallas.indexOf(b);
          return (
            (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB)
          );
        });

        const head = [["Color", ...tallas, "Total"]];
        const body = [];

        for (const color of Object.keys(agrupadoPorColor)) {
          let totalColor = 0;
          const row = [color];
          for (const talla of tallas) {
            const celdas = agrupadoPorColor[color][talla] || [];
            let celdaTexto = "";
            let subtotal = 0;
            celdas.forEach(({ cantidad, detalle }) => {
              celdaTexto += `${cantidad} ${detalle}\n`;
              subtotal += cantidad;
            });
            row.push(celdaTexto.trim());
            totalColor += subtotal;
          }
          row.push(totalColor);
          body.push(row);
        }

        doc.autoTable({
          head,
          body,
          startY: currentY,
          styles: {
            fontSize: 9,
            cellPadding: 0.8,
            valign: "middle",
            halign: "center",
            cellWidth: "wrap",
            overflow: "linebreak",
          },
          headStyles: {
            fillColor: [41, 128, 186],
            textColor: [255, 255, 255],
            fontStyle: "bold",
          },
        });

        currentY = doc.autoTable.previous.finalY + 8;

        // Mostrar bordados agrupados por articuloPedido (no repetidos por talla/color)
        const bordadosMap = new Map();

        grupo.forEach((a) => {
          const ap = a.articulosPedido?.[0];
          if (
            ap &&
            ap._id &&
            ap.bordados?.length > 0 &&
            !bordadosMap.has(ap._id)
          ) {
            bordadosMap.set(ap._id, ap.bordados);
          }
        });

        // Mostrar bordados una sola vez por grupo (no repetir por talla/color)
        const primer = grupo.find(
          (a) => a.articulosPedido?.[0]?.bordados?.length > 0,
        );
        const bordados = primer?.articulosPedido?.[0]?.bordados || [];

        if (bordados.length) {
          doc.setFont(undefined, "bold");
          doc.setFontSize(10);
          doc.text("Bordados:", 20, currentY);
          currentY += 5;

          let currentX = 20;
          let maxYInRow = 0;
          const imageMargin = 5;
          // x3: bordados 3 veces más grandes (2026-06)
          const maxImageHeight = 10 * 3;
          const maxImageWidth = 15 * 3;

          for (const b of bordados) {
            try {
              const url = `https://res.cloudinary.com/lynqro/image/upload/${b.public_id}`;
              const dataUrl = await getImageAsDataURL(url);

              const img = new Image();
              img.src = dataUrl;
              await new Promise((resolve) => {
                img.onload = () => {
                  const ratio = Math.min(
                    maxImageWidth / img.width,
                    maxImageHeight / img.height,
                  );
                  const imgW = img.width * ratio;
                  const imgH = img.height * ratio;

                  if (currentX + imgW > doc.internal.pageSize.getWidth() - 20) {
                    currentX = 20;
                    currentY += maxYInRow + 15;
                    maxYInRow = 0;
                  }

                  doc.addImage(dataUrl, "PNG", currentX, currentY, imgW, imgH);
                  doc.setFont(undefined, "normal");
                  doc.setFontSize(8);
                  doc.text(b.observacion || "", currentX, currentY + imgH + 4, {
                    maxWidth: imgW,
                  });

                  maxYInRow = Math.max(maxYInRow, imgH + 10);
                  currentX += imgW + imageMargin;
                  resolve();
                };
              });
            } catch (err) {
              console.warn("No se pudo cargar bordado:", b.public_id);
            }
          }

          currentY += maxYInRow + 10;
        }

        if (currentY > 270) {
          doc.addPage();
          currentY = 20;
        }
      }

      window.open(doc.output("bloburl"), "_blank");
    } catch (err) {
      console.error("Error generando PDF:", err);
      Swal.fire("Error", "No se pudo generar el PDF", "error");
    }
  }

  async function marcarRecibido(id, recibidoActual) {
    try {
      const nuevoEstado = recibidoActual === "Si" ? "No" : "Si";

      await axios.patch(
        `${URL_ORDENES_CORTE_EXTERNO}/${id}`,
        {
          recibido: nuevoEstado,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("app_token")}`,
          },
        },
      );

      Swal.fire({
        icon: "success",
        title: "Actualizado",
        text: `Estado cambiado a "${nuevoEstado}"`,
        timer: 1000,
        showConfirmButton: false,
      }).then(() => {
        window.location.reload(); // recarga toda la página
      });
    } catch (error) {
      console.error("Error al actualizar:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo actualizar el estado.",
      });
    }
  }

  const abrirChecklistAutorizacion = (idPedido) => {
    setIdPedidoEditando(idPedido);
    setChecks({
      Etiquetas: false,
      Tallas: false,
      Observaciones: false,
      Bordados: false,
      Modelos: false,
    });
    setModalCheck(true);
  };

  const autorizarPedido = async () => {
    try {
      const URL = `${process.env.REACT_APP_URL_ORDENES_CORTE_EXTERNO}/${idPedidoEditando}`;

      const res = await axios.patch(
        URL,
        { autorizacionVarios: "Si" },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      );

      // Actualizar estado local de pedidos
      setComments((prev) =>
        prev.map((p) =>
          p._id === idPedidoEditando ? { ...p, autorizacionVarios: "Si" } : p,
        ),
      );

      Swal.fire("Autorizado", "El pedido fue autorizado con éxito", "success");
      setModalCheck(false);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudo autorizar el pedido", "error");
    }
  };

  // (2026-10) Observaciones de la orden (p. ej. Graduación libera variantes).
  // Se editan aunque la orden ya esté autorizada; salen en el PDF de la orden.
  const [modalObs, setModalObs] = useState(false);
  const [obsOrden, setObsOrden] = useState({ id: "", numero: "", texto: "", subArea: "" });
  const [guardandoObs, setGuardandoObs] = useState(false);

  const abrirObservaciones = (a) => {
    const texto = String(a.observaciones || "").trim();
    const subArea = String(a.subArea || "").trim();
    setObsOrden({
      id: a._id,
      numero: a.numero,
      texto: texto.toUpperCase() === "NA" ? "" : texto,
      subArea: subArea.toUpperCase() === "NA" ? "" : subArea,
    });
    setModalObs(true);
  };

  const guardarObservaciones = async () => {
    const texto = obsOrden.texto.trim() || "NA";
    const subArea = String(obsOrden.subArea || "").trim() || "NA";
    setGuardandoObs(true);
    try {
      await axios.patch(
        `${process.env.REACT_APP_URL_ORDENES_CORTE_EXTERNO}/${obsOrden.id}`,
        { observaciones: texto, subArea },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      );
      await axios.post(
        URL_LOGS,
        {
          tipo: "Observaciones Orden Externa",
          detalle: `Orden ${obsOrden.numero}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      );
      setComments((prev) =>
        prev.map((p) =>
          p._id === obsOrden.id
            ? { ...p, observaciones: texto, subArea, cliente: conSubArea(p.clienteBase || p.cliente, subArea) }
            : p,
        ),
      );
      setModalObs(false);
      Swal.fire("Listo", "Observaciones guardadas", "success");
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudieron guardar las observaciones", "error");
    } finally {
      setGuardandoObs(false);
    }
  };

  const cambiarAutorizacionDirecto = async (id, nuevoValor) => {
    try {
      const URL = `${process.env.REACT_APP_URL_ORDENES_CORTE_EXTERNO}/${id}`;
      await axios.patch(
        URL,
        { autorizacionVarios: nuevoValor },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        },
      );

      setComments((prev) =>
        prev.map((p) =>
          p._id === id ? { ...p, autorizacionVarios: "No" } : p,
        ),
      );

      Swal.fire(
        "Actualizado",
        `El pedido fue marcado como "${nuevoValor}"`,
        "success",
      );
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudo actualizar el pedido", "error");
    }
  };

  // =====================================================
  // PROCESOS A MAQUILEROS (Salida / Entrada) + NotaCxP
  // =====================================================
  const tallaConVariante = (tallaObj) => {
    const base = tallaObj?.name || "";
    const variante = tallaObj?.variantesTallas?.[0]?.name || "";
    return variante ? `${base} ${variante}` : base;
  };

  // L3 (2026-06) — Devolución a Maquilero desde OCE.
  // Crea un DevolucionesProveedores + sus Acumulados ligando ordenesCorteExterno+maquilero.
  async function devolverMaquilero(idOCE, numeroOCE, maquileroNombre, idMaquilero) {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    // 1. cantidad a devolver (input simple por ahora)
    const { value: form } = await Swal.fire({
      title: `Devolución a Maquilero (OCE #${numeroOCE})`,
      html:
        `<div style="text-align:left;font-size:13px">` +
        `<p><b>Maquilero:</b> ${maquileroNombre || "(sin maquilero)"}</p>` +
        `<label>Piezas devueltas</label>` +
        `<input id="swal_qty" class="swal2-input" type="number" min="1" placeholder="Cantidad">` +
        `<label>Costo unitario</label>` +
        `<input id="swal_costo" class="swal2-input" type="number" min="0" step="0.01" placeholder="Costo por pieza">` +
        `<label>Observaciones</label>` +
        `<input id="swal_obs" class="swal2-input" type="text" placeholder="Motivo / detalle" value="Devolución desde OCE ${numeroOCE}">` +
        `</div>`,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Crear devolución",
      cancelButtonText: "Cancelar",
      preConfirm: () => {
        const qty = parseFloat(document.getElementById("swal_qty")?.value || 0);
        const costo = parseFloat(document.getElementById("swal_costo")?.value || 0);
        const obs = (document.getElementById("swal_obs")?.value || "").trim() || "NA";
        if (!qty || qty <= 0) {
          Swal.showValidationMessage("La cantidad debe ser mayor a 0");
          return false;
        }
        return { qty, costo, obs };
      },
    });

    if (!form) return;

    const hoy = moment().format("YYYY-MM-DD");
    const total_general = form.qty * (form.costo || 0);

    try {
      // 2. crea DevolucionesProveedores con ordenesCorteExterno + maquileros
      const resp = await axios.post(
        URL_DEVOLUCIONES_PROVEEDORES,
        {
          fecha: hoy,
          user: user.id,
          observaciones: form.obs,
          total_general,
          subTotal: total_general,
          iva: 0,
          total_cantidad: form.qty,
          aplicada: "No",
          ordenesCorteExterno: idOCE,
          maquileros: idMaquilero,
        },
        { headers }
      );

      const idDev = resp.data._id;

      // 3. crea el acumulado linea (sin articulos/tallas específicos por ahora — MVP)
      await axios.post(
        URL_DEVOLUCIONES_PROVEEDORES_ACUMULADOS,
        {
          fecha: hoy,
          cantidad: form.qty,
          devolucionesProveedores: idDev,
          ordenesCorteExterno: idOCE,
          costo: form.costo || 0,
        },
        { headers }
      );

      await axios.post(
        URL_LOGS,
        {
          tipo: "Devolución a Maquilero",
          detalle: `OCE ${numeroOCE} (${form.qty} pzas)`,
          user: user.id,
        },
        { headers }
      );

      Swal.fire({
        icon: "success",
        title: "Devolución creada",
        text: `Se creó la devolución a ${maquileroNombre}. Aplica el monto desde Admin → Devoluciones Proveedores.`,
      });
    } catch (err) {
      console.log("devolverMaquilero err:", err);
      Swal.fire("Error", "No se pudo crear la devolución", "error");
    }
  }

  function abrirSalidaProceso(idOrden, numeroOrden, idPedido, numeroPedido) {
    setSelectedOrdenExt(idOrden);
    setSelectedOrdenExtNumero(numeroOrden);
    setIdPedidoProc(idPedido);
    setNumeroPedidoProc(numeroPedido);
    setMaquileroProceso("");
    setIdCatalogoProceso("");
    setPrecioProceso(0);
    setFechaProceso(endDate);
    setFechaCompromisoProceso(endDate);
    setObservacionesProceso("NA");
    setTotalGeneralProc(0);

    axios
      .get(`${URL_ARTICULOS_ORDENES_CORTE_EXTERNO}/orden/${idOrden}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => {
        const data = response.data || [];
        const rows = data.map((a) => ({
          id: uuidv4(),
          idAreaCliente: a.areasClientes?.[0]?._id || "",
          areaCliente: a.areasClientes?.[0]?.name || "",
          idColor: a.colores?.[0]?._id || "",
          colores: a.colores?.[0]?.name || "",
          idTalla: a.tallas?.[0]?._id || "",
          tallas: tallaConVariante(a.tallas?.[0]),
          idArticulo: a.articulos?.[0]?._id || "",
          cantidad: parseFloat(a.cantidad) || 0,
          total: 0,
        }));
        setProcesosInputFields(rows);
        setIdArticuloProc(data?.[0]?.articulos?.[0]?._id || "");
        const TC = rows.reduce((t, c) => t + (parseFloat(c.cantidad) || 0), 0);
        setTotalPiezasProc(TC);
      })
      .catch((err) => console.log(err));

    toggleSalidaProc();
  }

  const handleProcPrecio = (valor) => {
    const precio = parseFloat(valor) || 0;
    setPrecioProceso(precio);
    setProcesosInputFields((prev) => {
      const next = prev.map((i) => ({
        ...i,
        total: (parseFloat(i.cantidad) || 0) * precio,
      }));
      const TG = next.reduce((t, c) => t + (parseFloat(c.total) || 0), 0);
      setTotalGeneralProc(TG);
      return next;
    });
  };

  const handleProcCantidad = (id, valor) => {
    setProcesosInputFields((prev) => {
      const next = prev.map((i) =>
        i.id === id
          ? {
              ...i,
              cantidad: parseFloat(valor) || 0,
              total: (parseFloat(valor) || 0) * (parseFloat(precioProceso) || 0),
            }
          : i
      );
      setTotalPiezasProc(
        next.reduce((t, c) => t + (parseFloat(c.cantidad) || 0), 0)
      );
      setTotalGeneralProc(
        next.reduce((t, c) => t + (parseFloat(c.total) || 0), 0)
      );
      return next;
    });
  };

  const saveSalidaProceso = async (event) => {
    event.preventDefault();
    if (!maquileroProceso || !idCatalogoProceso) {
      Swal.fire("Atención", "Selecciona proceso y maquilero", "warning");
      return;
    }
    if (!fechaProceso || !fechaCompromisoProceso) {
      Swal.fire("Atención", "Captura las fechas", "warning");
      return;
    }
    setValidaBoton(false);
    toggleProgreso();
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    try {
      const resp = await axios.post(
        URL_PROCESOS_SALIDA,
        {
          catalogoProcesos: idCatalogoProceso,
          proveedores: maquileroProceso,
          pedidos: idPedidoProc,
          fecha: fechaProceso,
          fechaCompromiso: fechaCompromisoProceso,
          observaciones: observacionesProceso || "NA",
          status: "Abierto",
          totalGeneral: totalGeneralProc,
          totalPiezas: totalPiezasProc,
          precio: precioProceso,
          ordenesCorteExterno: selectedOrdenExt,
          articulos: idArticuloProc,
        },
        { headers }
      );
      const procesoSalidaId = resp.data._id;

      for (const a of procesosInputFields) {
        if ((parseFloat(a.cantidad) || 0) <= 0) continue;
        await axios.post(
          URL_ARTICULOS_PROCESOS_SALIDA,
          {
            procesosSalida: procesoSalidaId,
            pedidos: idPedidoProc,
            cantidadSalida: parseFloat(a.cantidad) || 0,
            cantidadEntrada: 0,
            faltantes: parseFloat(a.cantidad) || 0,
            ordenesCorteExterno: selectedOrdenExt,
            articulos: a.idArticulo,
            colores: a.idColor,
            tallas: a.idTalla,
            areasClientes: a.idAreaCliente,
          },
          { headers }
        );
      }

      await axios.post(
        URL_LOGS,
        {
          tipo: "Salida de Proceso (Corte Externo)",
          detalle: `Orden ${selectedOrdenExtNumero} Pedido ${numeroPedidoProc}`,
          user: user.id,
        },
        { headers }
      );

      Swal.fire("Good job!", "Salida de proceso creada", "success");
      setTimeout(() => window.location.reload(), 1200);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo crear la salida de proceso",
        footer: `${error?.response?.data || ""}`,
      });
      setValidaBoton(true);
      setModalProgreso(false);
    }
  };

  function abrirEntradaLista(idOrden, numeroOrden) {
    setSelectedOrdenExt(idOrden);
    setSelectedOrdenExtNumero(numeroOrden);
    axios
      .get(`${URL_PROCESOS_SALIDA}/ordenCorteExterno/${idOrden}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => {
        const abiertos = (response.data || []).filter(
          (p) => p.status === "Abierto"
        );
        setProcesosSalidaAbiertos(abiertos);
      })
      .catch((err) => console.log(err));
    toggleEntradaLista();
  }

  function abrirEntradaProceso(proceso) {
    setSelectedProcesoSalida(proceso._id);
    setIdCatalogoProceso(proceso.catalogoProcesos?.[0]?._id || "");
    setMaquileroProceso(proceso.proveedores?.[0]?._id || "");
    setIdPedidoProc(proceso.pedidos?.[0]?._id || "");
    setIdArticuloProc(proceso.articulos?.[0]?._id || "");
    setPrecioProceso(proceso.precio || 0);
    setFechaProceso(endDate);
    setObservacionesProceso("NA");
    setImpuestosProc(0);
    setFacturaProc("NA");

    axios
      .get(`${URL_ARTICULOS_PROCESOS_SALIDA}/proceso/${proceso._id}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => {
        const data = response.data || [];
        const precio = parseFloat(proceso.precio) || 0;
        const rows = data.map((a) => ({
          id: uuidv4(),
          articulosProcesosSalida: a._id,
          idAreaCliente: a.areasClientes?.[0]?._id || "",
          areaCliente: a.areasClientes?.[0]?.name || "",
          idColor: a.colores?.[0]?._id || "",
          colores: a.colores?.[0]?.name || "",
          idTalla: a.tallas?.[0]?._id || "",
          tallas: tallaConVariante(a.tallas?.[0]),
          idArticulo: a.articulos?.[0]?._id || "",
          cantidad: parseFloat(a.faltantes) || 0,
          faltantes: 0,
          segundas: 0,
          total: (parseFloat(a.faltantes) || 0) * precio,
        }));
        setProcesosInputFields(rows);
        actualizaTotalesEntrada(rows);
      })
      .catch((err) => console.log(err));

    setModalEntradaLista(false);
    toggleEntradaProc();
  }

  const actualizaTotalesEntrada = (rows) => {
    const arr = rows || procesosInputFields;
    setTotalPiezasProc(arr.reduce((t, c) => t + (parseFloat(c.cantidad) || 0), 0));
    setTotalPiezasFaltantesProc(
      arr.reduce((t, c) => t + (parseFloat(c.faltantes) || 0), 0)
    );
    setTotalPiezasSegundasProc(
      arr.reduce((t, c) => t + (parseFloat(c.segundas) || 0), 0)
    );
    setTotalGeneralProc(arr.reduce((t, c) => t + (parseFloat(c.total) || 0), 0));
  };

  const handleEntradaInput = (id, campo, valor) => {
    setProcesosInputFields((prev) => {
      const next = prev.map((i) => {
        if (i.id !== id) return i;
        const fila = { ...i, [campo]: parseFloat(valor) || 0 };
        const cant = parseFloat(fila.cantidad) || 0;
        const seg = parseFloat(fila.segundas) || 0;
        const precio = parseFloat(precioProceso) || 0;
        fila.total = (cant + seg) * precio;
        return fila;
      });
      actualizaTotalesEntrada(next);
      return next;
    });
  };

  const saveEntradaProceso = async (event) => {
    event.preventDefault();
    if (!fechaProceso) {
      Swal.fire("Atención", "Captura la fecha", "warning");
      return;
    }
    setValidaBoton(false);
    toggleProgreso();
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    const ST = procesosInputFields.reduce(
      (t, c) => t + (parseFloat(c.total) || 0),
      0
    );
    const iva = impuestosProc != 0 ? (impuestosProc * ST) / 100 : 0;
    const TT = ST + iva;

    try {
      const resp = await axios.post(
        URL_PROCESOS_ENTRADA,
        {
          catalogoProcesos: idCatalogoProceso,
          proveedores: maquileroProceso,
          pedidos: idPedidoProc,
          fecha: fechaProceso,
          observaciones: observacionesProceso || "NA",
          totalGeneral: TT,
          totalPiezas: totalPiezasProc,
          totalPiezasFaltantes: totalPiezasFaltantesProc,
          totalPiezasSegundas: totalPiezasSegundasProc,
          precio: precioProceso,
          ordenesCorteExterno: selectedOrdenExt,
          procesosSalida: selectedProcesoSalida,
          factura: facturaProc || "NA",
          articulos: idArticuloProc,
          composturas: 0,
        },
        { headers }
      );
      const procesoEntradaId = resp.data._id;

      // NotaCxP al maquilero (igual que Cortes)
      const notaCxPResp = await axios.post(
        URL_NOTAS_CXP,
        {
          procesosEntrada: procesoEntradaId,
          proveedores: maquileroProceso,
          total_cantidad: totalPiezasProc + totalPiezasSegundasProc,
          fecha: fechaProceso,
          total_costo: TT,
          saldo: TT,
          subtotal: ST,
          iva,
          impuestos: impuestosProc,
          factura: facturaProc || "NA",
        },
        { headers }
      );

      for (const a of procesosInputFields) {
        if (
          (parseFloat(a.cantidad) || 0) !== 0 ||
          (parseFloat(a.faltantes) || 0) !== 0 ||
          (parseFloat(a.segundas) || 0) !== 0
        ) {
          await axios.post(
            URL_ARTICULOS_PROCESOS_ENTRADA,
            {
              procesosEntrada: procesoEntradaId,
              articulosProcesosSalida: a.articulosProcesosSalida,
              pedidos: idPedidoProc,
              cantidadEntrada: parseFloat(a.cantidad) || 0,
              cantidadFaltantes: parseFloat(a.faltantes) || 0,
              cantidadSegundas: parseFloat(a.segundas) || 0,
              ordenesCorteExterno: selectedOrdenExt,
              articulos: a.idArticulo,
              colores: a.idColor,
              tallas: a.idTalla,
              areasClientes: a.idAreaCliente,
            },
            { headers }
          );
        }
      }

      await axios.post(
        URL_LOGS,
        {
          tipo: "Entrada de Proceso (Corte Externo)",
          detalle: `Orden ${selectedOrdenExtNumero} Pedido ${numeroPedidoProc}`,
          user: user.id,
        },
        { headers }
      );

      // (2026-10) el PDF de la nota de CxP sale solo, con los renglones ya guardados
      setModalProgreso(false);
      await notaCxPPorId(notaCxPResp.data._id);

      Swal.fire("Good job!", "Entrada de proceso y NotaCxP creadas", "success");
      setTimeout(() => window.location.reload(), 1200);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo crear la entrada de proceso",
        footer: `${error?.response?.data || ""}`,
      });
      setValidaBoton(true);
      setModalProgreso(false);
    }
  };

  function verPDFPS(idOrden) {
    axios
      .get(`${URL_PROCESOS_SALIDA}/ordenCorteExterno/${idOrden}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => {
        const data = (response.data || []).map((a) => ({
          id: a._id,
          numero: a.idProcesosSalida,
          proceso: a.catalogoProcesos?.[0]?.name || "",
          maquilero: a.proveedores?.[0]?.nombre_comercial || "",
          fecha: a.fecha,
          fechaCompromiso: a.fechaCompromiso,
          totalPiezas: a.totalPiezas,
          precio: a.precio,
          totalGeneral: a.totalGeneral,
          status: a.status,
        }));
        setPDFPS(data);
      })
      .catch((err) => console.log(err));
    togglePDFPS();
  }

  function verPDFPE(idOrden) {
    axios
      .get(`${URL_PROCESOS_ENTRADA}/ordenCorteExterno/${idOrden}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => {
        const data = (response.data || []).map((a) => ({
          id: a._id,
          numero: a.idProcesosEntrada,
          proceso: a.catalogoProcesos?.[0]?.name || "",
          maquilero: a.proveedores?.[0]?.nombre_comercial || "",
          fecha: a.fecha,
          totalPiezas: a.totalPiezas,
          totalPiezasFaltantes: a.totalPiezasFaltantes,
          totalPiezasSegundas: a.totalPiezasSegundas,
          precio: a.precio,
          totalGeneral: a.totalGeneral,
          factura: a.factura,
        }));
        setPDFPE(data);
      })
      .catch((err) => console.log(err));
    togglePDFPE();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.menu_produccion ? (
                <>
                  {/* <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/OrdenesCorteCreate"
                >
                  Nueva Orden
                </Button> */}
                  <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    href="/OrdenesCorteExternoCreate"
                  >
                    Nueva Orden
                  </Button>
                </>
              ) : (
                <>
                  {/* <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Orden
                </Button> */}
                  <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    href="/OrdenesCorteExternoCreate"
                  >
                    Nueva Orden
                  </Button>
                </>
              )}
              <Button
                size="sm"
                href="/MenuProduccion"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                {user.ocx_pdf && (
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                )}
                {user.ocx_email && (
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                )}
                {user.ocx_excel && (
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                )}
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ordenes Compra</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ordenes Compra</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                // bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                // bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <div className="table-wrapper">
            <Table size="sm" striped borderless className="table-responsive-xl">
              <TableHeader
                headers={headers}
                onSorting={(field, order) => setSorting({ field, order })}
              />
              <tr>
                <td></td>
                <td></td>
                <td style={{ paddingTop: "0px" }}>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedCliente}
                    onChange={(e) => {
                      setSelectedCliente(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {clientes
                      .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1,
                      )
                      .map((a) => {
                        return (
                          <option value={a._id}>{a.nombre_comercial}</option>
                        );
                      })}
                  </Input>
                </td>
                <td style={{ paddingTop: "0px" }}>
                  {/* TF4 — filtro de proveedor (opciones desde las filas reales) */}
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedProveedor}
                    onChange={(e) => {
                      setSelectedProveedor(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    {[
                      ...new Map(
                        comments
                          .filter((c) => c.idProveedores)
                          .map((c) => [c.idProveedores, c.proveedor]),
                      ).entries(),
                    ]
                      .sort((a, b) =>
                        String(a[1]) > String(b[1]) ? 1 : -1,
                      )
                      .map(([id, nombre]) => (
                        <option value={id}>{nombre}</option>
                      ))}
                  </Input>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td style={{ paddingTop: "0px" }}>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedRecibido}
                    onChange={(e) => {
                      setSelectedRecibido(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </td>
                <td></td>
                <td></td>
              </tr>

              <tbody>
                {commentsData.map((a) => {
                  {
                    return (
                      <tr
                      //  style={ a.is_active== "No" ? { backgroundColor: "#ed8c8c" }: a.pedidoEditado =="Si" ? { backgroundColor: "#ffff00" } : undefined}
                      >
                        <td>{a.numero}</td>
                        <td>{a.fecha}</td>
                        <td>{a.cliente}</td>
                        <td>{a.proveedor}</td>
                        <td>{a.statusTela}</td>
                        <td>{a.observacionesMarca}</td>
                        <td>{a.marca}</td>
                        {/* <td>{a.fechaCancelacion}</td> */}
                        {/* (2026-08) artículos de la orden (código, descripción y piezas) */}
                        <td style={{ minWidth: 150 }}>
                          {(articulosPorOrden[a._id] || []).length ? (
                            (articulosPorOrden[a._id] || []).map((art, i) => (
                              <div key={i} title={art.descripcion || ""}>
                                {art.codigo}
                                {art.cantidad ? ` (${art.cantidad})` : ""}
                              </div>
                            ))
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                        <td>{a.total_piezas}</td>
                        <td style={{ minWidth: 160, maxWidth: 260 }}>
                          <div style={{ display: "flex", alignItems: "flex-start", gap: 6 }}>
                            <span style={{ whiteSpace: "pre-wrap", flex: 1 }}>
                              {String(a.observaciones || "").trim().toUpperCase() === "NA"
                                ? ""
                                : a.observaciones}
                            </span>
                            {a.is_active == "Si" && (
                              <Button
                                color="info"
                                size="sm"
                                title="Editar observaciones"
                                onClick={() => abrirObservaciones(a)}
                              >
                                <i className="fas fa-comment-alt"></i>
                              </Button>
                            )}
                          </div>
                        </td>
                        {/* <td>{a.pedido}</td>
                      <td>{a.cortado}</td> */}
                        <td>
                          {a.autorizacionVarios === "Si" ? (
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() =>
                                cambiarAutorizacionDirecto(a._id, "No")
                              }
                            >
                              <i className="fas fa-check-circle"></i>
                            </Button>
                          ) : (
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => abrirChecklistAutorizacion(a._id)}
                            >
                              <i className="fas fa-times-circle"></i>
                            </Button>
                          )}
                        </td>
                        <td>
                          {a.is_active == "Si" ? (
                            <>
                              <Button
                                size="sm"
                                className="btn"
                                color="danger"
                                onClick={async (e) => {
                                  // L88 (2026-06) — preguntar si separar por área
                                  const res = await Swal.fire({
                                    title: "¿Separar por área?",
                                    text: "Si dices Sí, cada área tendrá su propia banda en el PDF.",
                                    icon: "question",
                                    showCancelButton: true,
                                    confirmButtonText: "Sí, separar",
                                    cancelButtonText: "No, junto",
                                  });
                                  const separarPorArea = res.isConfirmed;
                                  PDFOC(
                                    a.numero,
                                    a.cliente,
                                    a.proveedor,
                                    a.proveedorDireccion,
                                    a.proveedorMail,
                                    a.fechaCompromiso,
                                    a.totalGeneral,
                                    a.fecha,
                                    a.pedido,
                                    a.idPedidos,
                                    a.total_piezas,
                                    a.observaciones,
                                    a.observacionesMarca,
                                    a.marca,
                                    a._id,
                                    a.idProveedor,
                                    a.nombreFirma,
                                    // L88 (2026-06)
                                    separarPorArea,
                                    // L106 (2026-06) — empresa del pedido
                                    a.empresa,
                                    // L128 (2026-07) — objeto empresa (datos fiscales)
                                    a.empresaObj,
                                  );
                                }}
                              >
                                <i class="far fa-file-pdf"></i>
                              </Button>
                              {/* <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) => requisicion(a._id, a.numero)}
                          >
                            <i class="fas fa-tag"></i>
                          </Button> */}
                              {/* (2026-08) Autorizada => no se editan los artículos */}
                              {!estaAutorizada(a) && (
                              <Button
                                color="info"
                                id="Editar"
                                size="sm"
                                onClick={(e) =>
                                  jalaEdit(
                                    a._id,
                                    a.numero,
                                    a.totalGeneral,
                                    a.observaciones,
                                  )
                                }
                              >
                                <i class="fas fa-cart-plus"></i>
                              </Button>
                              )}
                              {/* (2026-07) Consumos de telas (igual que ListadoPedidos) */}
                              <Button
                                color="info"
                                id="Consumos"
                                size="sm"
                                onClick={(e) =>
                                  ConsumoTelas(a.idPedidos, a.pedido, a.cliente)
                                }
                              >
                                <i class="fas fa-tape"></i>
                              </Button>
                              {/* {a.cortado == "No" ? (
                            <span>
                              <Button
                                color="primary"
                                id="Cerrar"
                                onClick={(e) => cortado(a._id)}
                                size="sm"
                              >
                                <i class="fas fa-cut"></i>
                              </Button>
                            </span>
                          ) : (
                            <span>
                              <Button
                                color="danger"
                                onClick={(e) => noCortado(a._id)}
                                size="sm"
                              >
                                <i class="fas fa-cut"></i>
                              </Button>
                            </span>
                          )} */}
                              <BajaMultiple
                                idStatus={a._id}
                                is_active={a.is_active}
                                URL_BAJA={
                                  process.env
                                    .REACT_APP_URL_ORDENES_CORTE_EXTERNO
                                }
                                hijo={`${process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE_EXTERNO}/baja`}
                              />
                            </>
                          ) : (
                            <BajaMultiple
                              idStatus={a._id}
                              is_active={a.is_active}
                              URL_BAJA={
                                process.env.REACT_APP_URL_ORDENES_CORTE_EXTERNO
                              }
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE_EXTERNO}/baja`}
                            />
                          )}
                        </td>
                        <td>
                          {a.is_active == "Si" ? (
                            <>
                              <Button
                                color="info"
                                id="Telas"
                                size="sm"
                                onClick={(e) => telasCortes(a._id, a.numero)}
                              >
                                <i class="fas fa-cart-plus"></i>
                              </Button>
                              <Button
                                color="success"
                                id="TelasDev"
                                size="sm"
                                onClick={(e) => telasCortesDev(a._id, a.numero)}
                              >
                                <i class="fas fa-undo-alt"></i>
                              </Button>
                              {/* <Button
                          size="sm"
                          className="btn"
                          color="danger"
                          onClick={(e) =>
                            PDFTelas(a.numero, a.fecha, a.pedido, a._id, a.total_piezas, a.cliente, a.articulo
                              // , a.patronista 
                            )
                          }
                        >
                          <i class="far fa-file-pdf"></i>
                        </Button> */}

                              <Button
                                size="sm"
                                className="btn"
                                color="danger"
                                onClick={(e) =>
                                  PDFTelasDetalles(
                                    a.numero,
                                    a.fecha,
                                    a.pedido,
                                    a._id,
                                    a.total_piezas,
                                    a.cliente,
                                    a.articulo,
                                    // , a.patronista
                                  )
                                }
                              >
                                <i class="fas fa-tape"></i>
                              </Button>
                            </>
                          ) : undefined}
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={(e) => statusEdit(a._id, a.statusTela)}
                          >
                            <i class="fas fa-edit"></i>
                          </Button>
                        </td>
                        {a.corteExterno == "Si" ? (
                          <td>
                            <Button
                              size="sm"
                              className="btn"
                              color="success"
                              onClick={(e) =>
                                jalaHabilitacion(
                                  a.id,
                                  a.idArticulo,
                                  a.idPedidos,
                                  a._id,
                                )
                              }
                            >
                              <i class="fas fa-tag"></i>
                            </Button>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => {
                                jalaHabilitacionEdit(a._id);
                              }}
                            >
                              <i class="far fa-edit"></i>
                            </Button>
                            {/* (2026-08) PDF SOLO de la habilitación */}
                            <Button
                              color="danger"
                              size="sm"
                              title="PDF de la habilitación"
                              onClick={(e) =>
                                PDFOC(
                                  a.numero,
                                  a.cliente,
                                  a.proveedor,
                                  a.proveedorDireccion,
                                  a.proveedorMail,
                                  a.fechaCompromiso,
                                  a.totalGeneral,
                                  a.fecha,
                                  a.pedido,
                                  a.idPedidos,
                                  a.total_piezas,
                                  a.observaciones,
                                  a.observacionesMarca,
                                  a.marca,
                                  a._id,
                                  a.idProveedor,
                                  a.nombreFirma,
                                  false,
                                  a.empresa,
                                  a.empresaObj,
                                  // solo la hoja de habilitación
                                  true
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                            {/* <Button
                          size="sm"
                          className="btn"
                          color="danger"
                          onClick={(e) =>
                            PDFOCHab(
                              a.numero,
                                a.cliente,
                                a.fecha,
                                a.pedido,
                                a.idPedidos,
                                a.articuloCodigo,
                                a.articuloDescripcion,
                                a.idArticulo,
                                a.total_piezas,
                                a.observaciones,
                                a._id
                            )
                          }
                        >
                          <i class="far fa-file-pdf"></i>
                        </Button> */}
                          </td>
                        ) : (
                          <td></td>
                        )}
                        <td style={{ minWidth: 220, whiteSpace: "nowrap" }}>
                          {(() => {
                            const lista = Array.isArray(a.recibidos)
                              ? a.recibidos
                              : [];
                            const yaMarcado = lista.some(
                              (r) => String(r.userId || "") === String(user.id)
                            );
                            return (
                              <Button
                                color={yaMarcado ? "primary" : "danger"}
                                size="sm"
                                title={
                                  yaMarcado
                                    ? "Quitar mi recibido"
                                    : "Marcar como recibido"
                                }
                                onClick={() =>
                                  toggleRecibido(a._id, a.recibidos)
                                }
                              >
                                <i className="fa-solid fa-check"></i>
                              </Button>
                            );
                          })()}
                          {Array.isArray(a.recibidos) && a.recibidos.length > 0 ? (
                            <div className="mt-1">
                              {a.recibidos.map((r, i) => (
                                <div key={i} style={{ whiteSpace: "nowrap" }}>
                                  <span style={{ color: "#000", fontSize: 13 }}>
                                    {r.nombre || "Usuario"}
                                    {r.fecha ? ` (${r.fecha})` : ""}
                                  </span>
                                </div>
                              ))}
                            </div>
                          ) : null}
                        </td>
                        <td>
                          {a.is_active == "Si" ? (
                            <Button
                              color="info"
                              size="sm"
                              title="Salida a Taller"
                              onClick={(e) =>
                                abrirSalidaProceso(
                                  a._id,
                                  a.numero,
                                  a.idPedidos,
                                  a.pedido,
                                )
                              }
                            >
                              <i class="fas fa-sign-out-alt"></i>
                            </Button>
                          ) : undefined}
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            title="Ver Salidas"
                            onClick={(e) => verPDFPS(a._id)}
                          >
                            <i class="fas fa-search"></i>
                          </Button>
                          {a.is_active == "Si" ? (
                            <Button
                              size="sm"
                              className="btn"
                              color="warning"
                              title="Devolución a Maquilero"
                              onClick={() =>
                                devolverMaquilero(
                                  a._id,
                                  a.numero,
                                  a.maquilero || "",
                                  a.idMaquilero || ""
                                )
                              }
                            >
                              <i class="fas fa-undo-alt"></i>
                            </Button>
                          ) : undefined}
                        </td>
                        <td>
                          {a.is_active == "Si" ? (
                            <Button
                              color="primary"
                              size="sm"
                              title="Entrada de Taller"
                              onClick={(e) => abrirEntradaLista(a._id, a.numero)}
                            >
                              <i class="fas fa-sign-in-alt"></i>
                            </Button>
                          ) : undefined}
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            title="Ver Entradas"
                            onClick={(e) => verPDFPE(a._id)}
                          >
                            <i class="fas fa-search"></i>
                          </Button>
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </Table>
          </div>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      {/* (2026-07) Consumos de telas por pedido — igual que ListadoPedidos */}
      <ConsumosTelasModal
        isOpen={modalConsumos}
        toggle={toggleConsumos}
        idPedido={consumoIdPedido}
        numeroPedido={consumoNumeroPedido}
        cliente={consumoCliente}
        onPDF={() =>
          PDFConsumosPorArticulo(consumoNumeroPedido, consumoCliente, consumoIdPedido)
        }
      />

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios minutos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalTelas} toggle={toggleTelas}>
        <ModalHeader toggle={toggleTelas}>
          <h4>
            Entrega de Tela de la Orden de Produccion {selectedOrdenCorteNumero}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveTelas}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaTelas}
                  required
                  onChange={(e) => {
                    setFechaTelas(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observacionesTelas}
                  required
                  onChange={(e) => {
                    setObservacionesTelas(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            {inputFieldsAnterior != "" ? (
              <>
                <Label>Tela Asignada</Label>
                <Row>
                  <Col md={2}>
                    <Label className="mr-sm-2">Articulo</Label>
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Tela</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Color</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Unidad</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Cantidad</Label>
                  </Col>
                </Row>

                {inputFieldsAnterior.map((inputFieldAnt) => (
                  <div key={inputFieldAnt.id}>
                    <Row>
                      <Col md={2}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.articulo}
                          disabled
                        />
                      </Col>
                      <Col md={3}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.telaNombre}
                          disabled
                        />
                      </Col>
                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.color}
                          disabled
                        />
                      </Col>
                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.unidad}
                          disabled
                        />
                      </Col>

                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.cantidad}
                          disabled
                        />
                      </Col>
                    </Row>
                  </div>
                ))}
              </>
            ) : undefined}
            <br />

            <Label>Asignar Tela</Label>
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Codigo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Tela</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Unidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.idArticulo}
                      onChange={(event) => {
                        handleChangeInputArticulo(inputField.id, event);
                      }}
                      tabindex="-1"
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosUnicos
                        .sort((a, b) =>
                          a.articuloNombre > b.articuloNombre ? 1 : -1,
                        )
                        .map((a) => {
                          return (
                            <option value={a.idArticulo}>
                              {a.articuloNombre}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      // bsSize="sm"
                      name="idInventarioTelas"
                      type="text"
                      value={inputField.idInventarioTelas}
                      onChange={(event) => {
                        BuscaRollo(inputField.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      // bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputField.telaNombre}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="unidad"
                      type="text"
                      value={inputField.unidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="text"
                      value={inputField.cantidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(totalKilos)}{" "}
                  kg. / {new Intl.NumberFormat("en-US").format(totalMetros)}{" "}
                  mts. / {rollosTotales} Rollos
                </h4>
              </Col>
            </Row>
            <br />

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalTelasDev} toggle={toggleTelasDev}>
        <ModalHeader toggle={toggleTelasDev}>
          <h4>
            Devolucion de Tela de la Orden de Produccion{" "}
            {selectedOrdenCorteNumeroDev}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveTelasDev}>
            {/* <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaTelas}
                  required
                  onChange={(e) => {
                    setFechaTelas(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observacionesTelas}
                  required
                  onChange={(e) => {
                    setObservacionesTelas(e.target.value);
                  }}
                />
              </Col>
            </Row> */}
            {/* <br />

            <Label>Devolver Tela</Label> */}
            <Row>
              {/* <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col> */}
              <Col md={3}>
                <Label className="mr-sm-2">Codigo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Tela</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Unidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad Original</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cant a Devolver</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  {/* <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.idArticulo}
                      onChange={(event) => {
                        handleChangeInputArticulo(inputField.id, event);
                      }}
                      tabindex="-1"
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosUnicos
                        .sort((a, b) =>
                          a.articuloNombre > b.articuloNombre ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a.idArticulo}>
                              {a.articuloNombre}
                            </option>
                          );
                        })}
                    </Input>
                  </Col> */}
                  <Col md={3}>
                    <Input
                      // bsSize="sm"
                      name="idInventarioTelas"
                      type="text"
                      value={inputField.idInventarioTelas}
                      onChange={(event) => {
                        BuscaRolloDev(inputField.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      // bsSize="sm"
                      name="tela"
                      type="text"
                      value={inputField.telas}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="unidad"
                      type="text"
                      value={inputField.unidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="text"
                      value={inputField.cantidadOriginal}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="text"
                      value={inputField.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInputCantidad(inputField.id, event)
                      }
                    ></Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(totalKilos)}{" "}
                  kg. / {new Intl.NumberFormat("en-US").format(totalMetros)}{" "}
                  mts. / {rollosTotalesDev} Rollos
                </h4>
              </Col>
            </Row>
            <br />

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalExplosion} toggle={toggleExplosion}>
        <ModalHeader toggle={toggleExplosion}>
          <h4>Explosion</h4>
        </ModalHeader>
        <ModalBody>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <tr>
              <th>Articulo</th>
              <th>Material</th>
              <th>Color</th>
              <th>Cantidad</th>
              <th>Total Cant</th>
            </tr>
            {explosion.map((a) => (
              <tr>
                <td>{a.articulosCodigo}</td>
                <td>{a.material}</td>
                <td>{a.coloresName}</td>
                <td>{a.cantidad}</td>
                <td>{a.cantidadTotal}</td>
              </tr>
            ))}
          </Table>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalObs} toggle={() => setModalObs(false)}>
        <ModalHeader toggle={() => setModalObs(false)}>
          <h4>Observaciones · Orden {obsOrden.numero}</h4>
        </ModalHeader>
        <ModalBody>
          {/* (2026-10) subárea del cliente: sale entre paréntesis junto al cliente */}
          <Label className="mr-sm-2">Subárea</Label>
          <Input
            type="text"
            placeholder="Subárea"
            value={obsOrden.subArea}
            onChange={(e) => {
              const subArea = e.target.value;
              setObsOrden((prev) => ({ ...prev, subArea }));
            }}
          />
          <br />
          <Label className="mr-sm-2">Observaciones</Label>
          <Input
            type="textarea"
            rows={5}
            placeholder="Ej. Graduación libera variantes..."
            value={obsOrden.texto}
            onChange={(e) => {
              const texto = e.target.value;
              setObsOrden((prev) => ({ ...prev, texto }));
            }}
            autoFocus
          />
          <small className="text-muted">Salen en el PDF de la orden.</small>
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            onClick={guardarObservaciones}
            disabled={guardandoObs}
          >
            {guardandoObs ? "Guardando..." : "Guardar"}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="xxl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar Articulos</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <Label className="mr-sm-2">Observaciones</Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observacionesEdit}
                required
                onChange={(e) => {
                  setObservacionesEdit(e.target.value);
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Articulo</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Area</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Precio</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Color</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Talla</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Total</Label>
            </Col>
          </Row>
          {sortedArticulosEdit.map((inputField) => (
            <div key={inputField._id}>
              <Row>
                <Col md={3}>
                  <Input
                    // bsSize="sm"
                    name="articulo"
                    type="text"
                    value={inputField.articulo}
                    disabled
                  ></Input>
                </Col>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="areasCliente"
                    type="text"
                    value={inputField.areasCliente}
                    disabled
                  ></Input>
                </Col>
                <Col md={1}>
  <Input
    name="precio"
    type="number"
    value={inputField.precio}
    onChange={(event) => handleChangeInputEdit(inputField._id, event)}
  />
</Col>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="color"
                    type="text"
                    value={inputField.color}
                    disabled
                  ></Input>
                </Col>
                <Col md={2}>
                  <Input
                    name="talla"
                    type="select"
                    value={inputField.idTalla}
                    onChange={(e) =>
                      handleChangeTallaEdit(inputField._id, e.target.value)
                    }
                  >
                    <option value="">Selecciona</option>
                    {tallasEdit.map((t) => (
                      <option key={t._id} value={t._id}>
                        {t.name}
                        {t.variantesTallas?.[0]?.name
                          ? " " + t.variantesTallas[0].name
                          : ""}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col md={1}>
                   <Input
    name="cantidad"
    type="number"
    value={inputField.cantidad}
    onChange={(event) => handleChangeInputEdit(inputField._id, event)}
  />
                </Col>
                <Col md={1}>
  <Input
    name="total"
    type="text"
    value={(parseFloat(inputField.cantidad) || 0) * (parseFloat(inputField.precio) || 0)}
    disabled
  />
</Col>
              </Row>
            </div>
          ))}

          {/* L124 — Agregar artículo del pedido (puede ser distinto a los que ya están) */}
          <hr />
          <Row>
            <Col md={12}>
              <Label className="mr-sm-2">
                <b>Agregar artículo / talla / color (debe estar en el pedido)</b>
              </Label>
            </Col>
          </Row>
          <Row className="align-items-end">
            <Col md={3}>
              <Label className="mr-sm-2">Artículo</Label>
              <Input
                type="select"
                value={agregarArticulo}
                onChange={(e) => cargaCatalogoArticuloAgregar(e.target.value)}
              >
                <option value="">Selecciona</option>
                {(articulosPedidoEdit.length
                  ? articulosPedidoEdit
                  : articulosUnicosEdit
                ).map((a) => (
                  <option key={a.id} value={a.id}>
                    {a.nombre}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Color</Label>
              <Input
                type="select"
                value={agregarColor}
                disabled={!agregarArticulo}
                onChange={(e) => setAgregarColor(e.target.value)}
              >
                <option value="">Selecciona</option>
                {agregarColores.map((c) => (
                  <option key={c._id} value={c._id}>
                    {c.name}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Talla</Label>
              <Input
                type="select"
                value={agregarTalla}
                disabled={!agregarArticulo}
                onChange={(e) => setAgregarTalla(e.target.value)}
              >
                <option value="">Selecciona</option>
                {agregarTallas.map((t) => (
                  <option key={t._id} value={t._id}>
                    {t.name}
                    {t.variantesTallas?.[0]?.name
                      ? " " + t.variantesTallas[0].name
                      : ""}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
              <Input
                type="number"
                min="0"
                value={agregarCantidad}
                onChange={(e) => setAgregarCantidad(e.target.value)}
              />
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Precio</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={agregarPrecio}
                onChange={(e) => setAgregarPrecio(e.target.value)}
              />
            </Col>
            <Col md={2}>
              <Button
                type="button"
                color="primary"
                size="sm"
                onClick={agregarTallaColor}
                disabled={!agregarArticulo}
              >
                Agregar
              </Button>
            </Col>
          </Row>
          <hr />

          <Row>
            <Col md={9}></Col>
            <Col md={1}>
              <Label>Totales</Label>
            </Col>
            <Col md={1}>
              <Label>{total_piezas}</Label>
            </Col>
            <Col md={1}>
              <Label>{totalGeneral}</Label>
            </Col>
          </Row>
          {validaBoton ? (
            <Button
              type="submit"
              className="btn btn-success"
              onClick={saveEdit}
            >
              Guardar
            </Button>
          ) : (
            <Button type="submit" className="btn btn-success" disabled>
              Guardar
            </Button>
          )}
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalStatusEdit} toggle={toggleStatusEdit}>
        <ModalHeader toggle={toggleStatusEdit}>
          <h3>Editar Status</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveStatusEdit}>
            <Row>
              <Col md={12}>
                <Label>Status</Label>
                <Input
                  type="select"
                  value={statusTelaEdit}
                  required
                  onChange={(e) => {
                    setStatusTelaEdit(e.target.value);
                  }}
                >
                  <option value="Pendiente">Pendiente</option>
                  <option value="Completo">Completo</option>
                  <option value="Incompleto">Incompleto</option>
                  <option value="No llevara">No llevara</option>
                </Input>
              </Col>
            </Row>
            <Row></Row>
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalHabilitacion} toggle={toggleHabilitacion}>
        <ModalHeader toggle={toggleHabilitacion}>
          <h3>Entregar Habilitacion</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveHabilitacion}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  bsSize="sm"
                  type="date"
                  value={fechaHab}
                  onChange={(event) => {
                    setFechaHab(event.target.value);
                  }}
                ></Input>
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                <Label className="mr-sm-2">Material</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>

            {inputFieldsHabilitacion.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={8}>
                    {/* (2026-07) buscador autocomplete de habilitación */}
                    <Autocomplete
                      size="small"
                      options={habilitacion
                        .slice()
                        .sort((a, b) =>
                          a.descripcion > b.descripcion ? 1 : -1,
                        )}
                      getOptionLabel={(o) =>
                        `${o?.descripcion || ""} ${o?.nombre || ""}`.trim()
                      }
                      getOptionSelected={(o, v) =>
                        String(o?._id) === String(v?._id)
                      }
                      value={
                        habilitacion.find(
                          (h) =>
                            String(h._id) === String(inputField.idHabilitacion),
                        ) || null
                      }
                      onChange={(event, sel) => {
                        handleChangeInputHabilitacion(inputField.id, {
                          target: {
                            name: "idHabilitacion",
                            value: sel?._id || "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Buscar habilitación..."
                          variant="outlined"
                        />
                      )}
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={inputField.cantidad}
                      onChange={(event) => {
                        handleChangeInputHabilitacion(inputField.id, event);
                      }}
                    ></Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFieldsHabilitacion.length === 1}
                      onClick={() =>
                        handleRemoveFieldsHabilitaccion(inputField.id)
                      }
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsHabilitacion}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalEditHab} toggle={toggleEditHab}>
        <ModalHeader toggle={toggleEditHab}>
          <h3>Editar Habilitacion</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveHabilitacionEdit}>
            <Row>
              <Col md={9}>
                <Label>Observaiones</Label>
                <Input
                  bsSize="sm"
                  type="text"
                  value={observacionesHab}
                  onChange={(event) => {
                    setObservacionesHab(event.target.value);
                  }}
                ></Input>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={8}>
                <Label className="mr-sm-2">Material</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad Anterior</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad Nueva</Label>
              </Col>
            </Row>

            {editHab.map((a) => (
              <div key={a.id}>
                <Row>
                  <Col md={8}>
                    <Input
                      bsSize="sm"
                      name="nombre"
                      type="string"
                      value={a.nombre}
                      disabled
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={a.cantidadAnterior}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={a.cantidad}
                      onChange={(event) => {
                        handleChangeInputHabilitacionEdit(a.id, event);
                      }}
                    ></Input>
                  </Col>
                </Row>
              </div>
            ))}
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalCheck} toggle={() => setModalCheck(false)}>
        <ModalHeader toggle={() => setModalCheck(false)}>
          Verificación antes de autorizar
        </ModalHeader>
        <ModalBody>
          <table style={{ width: "100%" }}>
            <tbody>
              {Object.entries(checks).map(([key, value]) => (
                <tr key={key} style={{ height: "40px" }}>
                  <td style={{ width: "40px", verticalAlign: "middle" }}>
                    <Input
                      type="checkbox"
                      checked={value}
                      onChange={() =>
                        setChecks((prev) => ({ ...prev, [key]: !prev[key] }))
                      }
                    />
                  </td>
                  <td style={{ verticalAlign: "middle", fontSize: "16px" }}>
                    {key}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            disabled={!Object.values(checks).every((v) => v)}
            onClick={autorizarPedido}
          >
            Autorizar
          </Button>
          <Button color="secondary" onClick={() => setModalCheck(false)}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* ===== Modal Salida a Taller (Corte Externo) ===== */}
      <Modal size="xxl" isOpen={modalSalidaProc} toggle={toggleSalidaProc}>
        <ModalHeader toggle={toggleSalidaProc}>
          <h4>Salida a Taller - Orden {selectedOrdenExtNumero}</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveSalidaProceso}>
            <Row>
              <Col md={3}>
                <Label>Proceso</Label>
                <Input
                  type="select"
                  value={idCatalogoProceso}
                  required
                  onChange={(e) => setIdCatalogoProceso(e.target.value)}
                >
                  <option value="">Selecciona</option>
                  {catalogoProcesos
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => (
                      <option value={a._id} key={a._id}>
                        {a.name}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Maquilero</Label>
                <Input
                  type="select"
                  value={maquileroProceso}
                  required
                  onChange={(e) => setMaquileroProceso(e.target.value)}
                >
                  <option value="">Selecciona</option>
                  {maquileros
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => (
                      <option value={a._id} key={a._id}>
                        {a.nombre_comercial}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Precio</Label>
                <Input
                  type="number"
                  value={precioProceso}
                  required
                  onChange={(e) => handleProcPrecio(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  value={fechaProceso}
                  required
                  onChange={(e) => setFechaProceso(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <Label>Fecha Compromiso</Label>
                <Input
                  type="date"
                  value={fechaCompromisoProceso}
                  required
                  onChange={(e) => setFechaCompromisoProceso(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={12}>
                <Label>Observaciones</Label>
                <Input
                  type="text"
                  value={observacionesProceso}
                  onChange={(e) => setObservacionesProceso(e.target.value)}
                />
              </Col>
            </Row>
            <br />
            <Row className="fw-bold text-center">
              <Col md={3}>Área</Col>
              <Col md={3}>Color</Col>
              <Col md={3}>Talla</Col>
              <Col md={3}>Cantidad</Col>
            </Row>
            {procesosInputFields.map((f) => (
              <Row key={f.id} className="align-items-center text-center mb-1">
                <Col md={3}>{f.areaCliente}</Col>
                <Col md={3}>{f.colores}</Col>
                <Col md={3}>{f.tallas}</Col>
                <Col md={3}>
                  <Input
                    type="number"
                    value={f.cantidad}
                    onChange={(e) => handleProcCantidad(f.id, e.target.value)}
                  />
                </Col>
              </Row>
            ))}
            <br />
            <Row>
              <Col md={6}>
                <h5>
                  Piezas: {totalPiezasProc} / Total: $
                  {new Intl.NumberFormat("en-US").format(totalGeneralProc)}
                </h5>
              </Col>
              <Col md={6} className="text-end">
                <Button type="submit" color="success" disabled={!validaBoton}>
                  Guardar Salida
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>

      {/* ===== Modal lista de Salidas abiertas para Entrada ===== */}
      <Modal size="xl" isOpen={modalEntradaLista} toggle={toggleEntradaLista}>
        <ModalHeader toggle={toggleEntradaLista}>
          <h4>Entrada de Taller - Orden {selectedOrdenExtNumero}</h4>
        </ModalHeader>
        <ModalBody>
          <Table>
            <tr>
              <th>#</th>
              <th>Proceso</th>
              <th>Maquilero</th>
              <th>Piezas</th>
              <th>Precio</th>
              <th>Recibir</th>
            </tr>
            {procesosSalidaAbiertos.map((p) => (
              <tr key={p._id}>
                <td>{p.idProcesosSalida}</td>
                <td>{p.catalogoProcesos?.[0]?.name}</td>
                <td>{p.proveedores?.[0]?.nombre_comercial}</td>
                <td>{p.totalPiezas}</td>
                <td>{p.precio}</td>
                <td>
                  <Button
                    size="sm"
                    color="success"
                    onClick={() => abrirEntradaProceso(p)}
                  >
                    <i className="fas fa-sign-in-alt"></i>
                  </Button>
                </td>
              </tr>
            ))}
          </Table>
        </ModalBody>
      </Modal>

      {/* ===== Modal Entrada de Taller (captura) ===== */}
      <Modal size="xxl" isOpen={modalEntradaProc} toggle={toggleEntradaProc}>
        <ModalHeader toggle={toggleEntradaProc}>
          <h4>Recibir Proceso - Orden {selectedOrdenExtNumero}</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveEntradaProceso}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  value={fechaProceso}
                  required
                  onChange={(e) => setFechaProceso(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <Label>Impuestos %</Label>
                <Input
                  type="number"
                  value={impuestosProc}
                  onChange={(e) =>
                    setImpuestosProc(parseFloat(e.target.value) || 0)
                  }
                />
              </Col>
              <Col md={3}>
                <Label>Factura</Label>
                <Input
                  type="text"
                  value={facturaProc}
                  onChange={(e) => setFacturaProc(e.target.value)}
                />
              </Col>
              <Col md={4}>
                <Label>Observaciones</Label>
                <Input
                  type="text"
                  value={observacionesProceso}
                  onChange={(e) => setObservacionesProceso(e.target.value)}
                />
              </Col>
            </Row>
            <br />
            <Row className="fw-bold text-center">
              <Col md={2}>Área</Col>
              <Col md={2}>Color</Col>
              <Col md={2}>Talla</Col>
              <Col md={2}>Recibido</Col>
              <Col md={2}>Faltantes</Col>
              <Col md={2}>Segundas</Col>
            </Row>
            {procesosInputFields.map((f) => (
              <Row key={f.id} className="align-items-center text-center mb-1">
                <Col md={2}>{f.areaCliente}</Col>
                <Col md={2}>{f.colores}</Col>
                <Col md={2}>{f.tallas}</Col>
                <Col md={2}>
                  <Input
                    type="number"
                    value={f.cantidad}
                    onChange={(e) =>
                      handleEntradaInput(f.id, "cantidad", e.target.value)
                    }
                  />
                </Col>
                <Col md={2}>
                  <Input
                    type="number"
                    value={f.faltantes}
                    onChange={(e) =>
                      handleEntradaInput(f.id, "faltantes", e.target.value)
                    }
                  />
                </Col>
                <Col md={2}>
                  <Input
                    type="number"
                    value={f.segundas}
                    onChange={(e) =>
                      handleEntradaInput(f.id, "segundas", e.target.value)
                    }
                  />
                </Col>
              </Row>
            ))}
            <br />
            <Row>
              <Col md={8}>
                <h5>
                  Recibido: {totalPiezasProc} / Faltantes:{" "}
                  {totalPiezasFaltantesProc} / Segundas:{" "}
                  {totalPiezasSegundasProc} / Subtotal: $
                  {new Intl.NumberFormat("en-US").format(totalGeneralProc)}
                </h5>
              </Col>
              <Col md={4} className="text-end">
                <Button type="submit" color="success" disabled={!validaBoton}>
                  Guardar Entrada + NotaCxP
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>

      {/* ===== Modal visor Salidas (PDFPS) ===== */}
      <Modal size="xl" isOpen={modalPDFPS} toggle={togglePDFPS}>
        <ModalHeader toggle={togglePDFPS}>
          <h4>Salidas de Proceso</h4>
        </ModalHeader>
        <ModalBody>
          <Table>
            <tr>
              <th>#</th>
              <th>Proceso</th>
              <th>Maquilero</th>
              <th>Fecha</th>
              <th>Compromiso</th>
              <th>Piezas</th>
              <th>Precio</th>
              <th>Total</th>
              <th>Status</th>
            </tr>
            {PDFPS.map((a) => (
              <tr key={a.id}>
                <td>{a.numero}</td>
                <td>{a.proceso}</td>
                <td>{a.maquilero}</td>
                <td>{a.fecha}</td>
                <td>{a.fechaCompromiso}</td>
                <td>{a.totalPiezas}</td>
                <td>{a.precio}</td>
                <td>
                  {"$" +
                    new Intl.NumberFormat("en-US").format(a.totalGeneral || 0)}
                </td>
                <td>{a.status}</td>
              </tr>
            ))}
          </Table>
        </ModalBody>
      </Modal>

      {/* ===== Modal visor Entradas (PDFPE) ===== */}
      <Modal size="xl" isOpen={modalPDFPE} toggle={togglePDFPE}>
        <ModalHeader toggle={togglePDFPE}>
          <h4>Entradas de Proceso</h4>
        </ModalHeader>
        <ModalBody>
          <Table>
            <tr>
              <th>#</th>
              <th>Proceso</th>
              <th>Maquilero</th>
              <th>Fecha</th>
              <th>Recibidas</th>
              <th>Faltantes</th>
              <th>Segundas</th>
              <th>Precio</th>
              <th>Total</th>
              <th>Factura</th>
            </tr>
            {PDFPE.map((a) => (
              <tr key={a.id}>
                <td>{a.numero}</td>
                <td>{a.proceso}</td>
                <td>{a.maquilero}</td>
                <td>{a.fecha}</td>
                <td>{a.totalPiezas}</td>
                <td>{a.totalPiezasFaltantes}</td>
                <td>{a.totalPiezasSegundas}</td>
                <td>{a.precio}</td>
                <td>
                  {"$" +
                    new Intl.NumberFormat("en-US").format(a.totalGeneral || 0)}
                </td>
                <td>{a.factura}</td>
              </tr>
            ))}
          </Table>
        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoOrdenesCorteExterno;
